// Translation dictionary - English to Traditional Chinese
// This dictionary can be used across all reading styles for word translations
//
// Structure:
// 1. Simple string: "cat": "貓"
// 2. Array of translations: "old": ["舊的", "年老的"]
// 3. Object with part of speech:
//    "cat": { pos: "名詞", translation: "貓" }
//    "old": { pos: "形容詞", translations: ["舊的", "年老的"] }
//
// Part of speech (pos) options:
// 名詞 (noun), 動詞 (verb), 形容詞 (adjective), 副詞 (adverb),
// 代名詞 (pronoun), 介系詞 (preposition), 連接詞 (conjunction),
// 冠詞 (article), 助動詞 (auxiliary verb), 數詞 (numeral)

const TRANSLATION_DICTIONARY = {
  // Articles
  the: { pos: "冠詞", translation: "這" },
  a: { pos: "冠詞", translation: "一個" },
  an: { pos: "冠詞", translation: "一個" },

  // Conjunctions
  and: { pos: "連接詞", translation: "和" },
  or: { pos: "連接詞", translation: "或" },
  but: { pos: "連接詞", translation: "但是" },

  // Be verbs
  is: { pos: "動詞", translation: "是" },
  are: { pos: "動詞", translation: "是" },
  was: { pos: "動詞", translation: "是" },
  were: { pos: "動詞", translation: "是" },
  am: { pos: "動詞", translation: "是" },
  be: { pos: "動詞", translation: "是" },
  been: { pos: "動詞", translation: "已經是" },
  being: { pos: "動詞", translation: "正在是" },

  // Auxiliary verbs
  have: { pos: "助動詞", translation: "有" },
  has: { pos: "助動詞", translation: "有" },
  had: { pos: "助動詞", translation: "有" },
  do: { pos: "助動詞", translation: "做" },
  does: { pos: "助動詞", translation: "做" },
  did: { pos: "助動詞", translation: "做" },
  will: { pos: "助動詞", translation: "將" },
  would: { pos: "助動詞", translation: "會" },
  should: { pos: "助動詞", translation: "應該" },
  could: { pos: "助動詞", translation: "可以" },
  can: { pos: "助動詞", translation: "能" },
  may: { pos: "助動詞", translation: "可能" },
  might: { pos: "助動詞", translation: "可能" },
  must: { pos: "助動詞", translation: "必須" },

  // Pronouns
  i: { pos: "代名詞", translation: "我" },
  you: { pos: "代名詞", translation: "你" },
  he: { pos: "代名詞", translation: "他" },
  she: { pos: "代名詞", translation: "她" },
  it: { pos: "代名詞", translation: "它" },
  we: { pos: "代名詞", translation: "我們" },
  they: { pos: "代名詞", translation: "他們" },
  me: { pos: "代名詞", translation: "我" },
  him: { pos: "代名詞", translation: "他" },
  her: { pos: "代名詞", translation: "她" },
  us: { pos: "代名詞", translation: "我們" },
  them: { pos: "代名詞", translation: "他們" },
  my: { pos: "代名詞", translation: "我的" },
  your: { pos: "代名詞", translation: "你的" },
  his: { pos: "代名詞", translation: "他的" },
  its: { pos: "代名詞", translation: "它的" },
  our: { pos: "代名詞", translation: "我們的" },
  their: { pos: "代名詞", translation: "他們的" },

  // Common verbs
  go: { pos: "動詞", translation: "去" },
  went: { pos: "動詞", translation: "去了" },
  gone: { pos: "動詞", translation: "去了" },
  come: { pos: "動詞", translation: "來" },
  came: { pos: "動詞", translation: "來了" },
  see: { pos: "動詞", translation: "看" },
  saw: { pos: "動詞", translation: "看見了" },
  seen: { pos: "動詞", translation: "看見" },
  look: { pos: "動詞", translation: "看" },
  watch: { pos: "動詞", translation: "觀看" },
  read: { pos: "動詞", translation: "讀" },
  write: { pos: "動詞", translation: "寫" },
  speak: { pos: "動詞", translation: "說" },
  talk: { pos: "動詞", translation: "說話" },
  listen: { pos: "動詞", translation: "聽" },
  hear: { pos: "動詞", translation: "聽見" },
  eat: { pos: "動詞", translation: "吃" },
  drink: { pos: "動詞", translation: "喝" },
  sleep: { pos: "動詞", translation: "睡覺" },
  wake: { pos: "動詞", translation: "醒來" },
  walk: { pos: "動詞", translation: "走" },
  run: { pos: "動詞", translation: "跑" },
  jump: { pos: "動詞", translation: "跳" },
  hop: { pos: "動詞", translation: "單腳跳" },
  skip: { pos: "動詞", translation: "跳躍" },
  climb: { pos: "動詞", translation: "爬" },
  crawl: { pos: "動詞", translation: "爬行" },
  dance: { pos: "動詞", translation: "跳舞" },
  sing: { pos: "動詞", translation: "唱歌" },
  play: { pos: "動詞", translation: "玩" },
  sit: { pos: "動詞", translation: "坐" },
  sat: { pos: "動詞", translation: "坐" },
  stand: { pos: "動詞", translation: "站" },
  stood: { pos: "動詞", translation: "站" },
  lie: { pos: "動詞", translation: "躺" },
  laugh: { pos: "動詞", translation: "笑" },
  cry: { pos: "動詞", translation: "哭" },
  smile: { pos: "動詞", translation: "微笑" },
  like: { pos: "動詞", translation: "喜歡" },
  love: { pos: "動詞", translation: "愛" },
  want: { pos: "動詞", translation: "想要" },
  need: { pos: "動詞", translation: "需要" },
  know: { pos: "動詞", translation: "知道" },
  think: { pos: "動詞", translation: "想" },
  feel: { pos: "動詞", translation: "感覺" },
  say: { pos: "動詞", translation: "說" },
  said: { pos: "動詞", translation: "說了" },
  tell: { pos: "動詞", translation: "告訴" },
  told: { pos: "動詞", translation: "告訴了" },
  ask: { pos: "動詞", translation: "問" },
  answer: { pos: "動詞", translation: "回答" },
  call: { pos: "動詞", translation: "叫" },
  shout: { pos: "動詞", translation: "喊" },
  yell: { pos: "動詞", translation: "大叫" },
  whisper: { pos: "動詞", translation: "低語" },
  give: { pos: "動詞", translation: "給" },
  gave: { pos: "動詞", translation: "給了" },
  take: { pos: "動詞", translation: "拿" },
  took: { pos: "動詞", translation: "拿了" },
  bring: { pos: "動詞", translation: "帶來" },
  brought: { pos: "動詞", translation: "帶來了" },
  carry: { pos: "動詞", translation: "攜帶" },
  hold: { pos: "動詞", translation: "拿著" },
  catch: { pos: "動詞", translation: "接住" },
  throw: { pos: "動詞", translation: "扔" },
  push: { pos: "動詞", translation: "推" },
  pull: { pos: "動詞", translation: "拉" },
  open: { pos: "動詞", translation: "打開" },
  close: { pos: "動詞", translation: "關閉" },
  make: { pos: "動詞", translation: "做" },
  made: { pos: "動詞", translation: "做了" },
  build: { pos: "動詞", translation: "建造" },
  draw: { pos: "動詞", translation: "畫" },
  color: { pos: "動詞", translation: "塗色" },
  paint: { pos: "動詞", translation: "畫畫" },
  cut: { pos: "動詞", translation: "剪" },
  paste: { pos: "動詞", translation: "粘貼" },
  get: { pos: "動詞", translation: "得到" },
  got: { pos: "動詞", translation: "得到了" },
  put: { pos: "動詞", translation: "放" },
  find: { pos: "動詞", translation: "找到" },
  found: { pos: "動詞", translation: "找到了" },
  show: { pos: "動詞", translation: "展示" },
  share: { pos: "動詞", translation: "分享" },
  help: { pos: "動詞", translation: "幫助" },
  clean: { pos: "動詞", translation: "清潔" },
  wash: { pos: "動詞", translation: "洗" },
  brush: { pos: "動詞", translation: "刷" },

  // Common nouns - Animals
  cat: { pos: "名詞", translation: "貓" },
  dog: { pos: "名詞", translation: "狗" },
  bird: { pos: "名詞", translation: "鳥" },
  fish: { pos: "名詞", translation: "魚" },
  animal: { pos: "名詞", translation: "動物" },
  horse: { pos: "名詞", translation: "馬" },
  cow: { pos: "名詞", translation: "牛" },
  butterfly: { pos: "名詞", translation: "蝴蝶" },
  spider: { pos: "名詞", translation: "蜘蛛" },
  frog: { pos: "名詞", translation: "青蛙" },
  lion: { pos: "名詞", translation: "獅子" },
  tiger: { pos: "名詞", translation: "老虎" },
  bear: { pos: "名詞", translation: "熊" },
  elephant: { pos: "名詞", translation: "大象" },
  kangaroo: { pos: "名詞", translation: "袋鼠" },
  rabbit: { pos: "名詞", translation: "兔子" },
  pony: { pos: "名詞", translation: "小馬" },
  duck: { pos: "名詞", translation: "鴨子" },
  chicken: { pos: "名詞", translation: "雞" },
  sheep: { pos: "名詞", translation: "羊" },
  pig: { pos: "名詞", translation: "豬" },
  person: { pos: "名詞", translation: "人" },
  people: { pos: "名詞", translation: "人們" },
  man: { pos: "名詞", translation: "男人" },
  woman: { pos: "名詞", translation: "女人" },
  child: { pos: "名詞", translation: "孩子" },
  children: { pos: "名詞", translation: "孩子們" },
  boy: { pos: "名詞", translation: "男孩" },
  girl: { pos: "名詞", translation: "女孩" },
  baby: { pos: "名詞", translation: "嬰兒" },
  friend: { pos: "名詞", translation: "朋友" },
  family: { pos: "名詞", translation: "家庭" },
  mother: { pos: "名詞", translation: "媽媽" },
  father: { pos: "名詞", translation: "爸爸" },
  mom: { pos: "名詞", translation: "媽媽" },
  dad: { pos: "名詞", translation: "爸爸" },
  brother: { pos: "名詞", translation: "兄弟" },
  sister: { pos: "名詞", translation: "姐妹" },
  grandpa: { pos: "名詞", translation: "爺爺" },
  grandma: { pos: "名詞", translation: "奶奶" },
  grandfather: { pos: "名詞", translation: "爺爺" },
  grandmother: { pos: "名詞", translation: "奶奶" },
  aunt: { pos: "名詞", translation: "阿姨" },
  uncle: { pos: "名詞", translation: "叔叔" },
  cousin: { pos: "名詞", translation: "表兄弟姐妹" },
  teacher: { pos: "名詞", translation: "老師" },
  student: { pos: "名詞", translation: "學生" },
  doctor: { pos: "名詞", translation: "醫生" },
  firefighter: { pos: "名詞", translation: "消防員" },
  farmer: { pos: "名詞", translation: "農夫" },
  artist: { pos: "名詞", translation: "藝術家" },
  musician: { pos: "名詞", translation: "音樂家" },
  book: { pos: "名詞", translation: "書" },
  pen: { pos: "名詞", translation: "筆" },
  pencil: { pos: "名詞", translation: "鉛筆" },
  paper: { pos: "名詞", translation: "紙" },
  table: { pos: "名詞", translation: "桌子" },
  chair: { pos: "名詞", translation: "椅子" },
  desk: { pos: "名詞", translation: "書桌" },
  door: { pos: "名詞", translation: "門" },
  window: { pos: "名詞", translation: "窗戶" },
  house: { pos: "名詞", translation: "房子" },
  home: { pos: "名詞", translation: "家" },
  room: { pos: "名詞", translation: "房間" },
  school: { pos: "名詞", translation: "學校" },
  class: { pos: "名詞", translation: "班級" },
  playground: { pos: "名詞", translation: "遊樂場" },
  park: { pos: "名詞", translation: "公園" },
  beach: { pos: "名詞", translation: "海灘" },
  pond: { pos: "名詞", translation: "池塘" },
  ocean: { pos: "名詞", translation: "海洋" },
  mountain: { pos: "名詞", translation: "山" },

  // Body parts
  head: { pos: "名詞", translation: "頭" },
  face: { pos: "名詞", translation: "臉" },
  eye: { pos: "名詞", translation: "眼睛" },
  eyes: { pos: "名詞", translation: "眼睛" },
  ear: { pos: "名詞", translation: "耳朵" },
  ears: { pos: "名詞", translation: "耳朵" },
  nose: { pos: "名詞", translation: "鼻子" },
  mouth: { pos: "名詞", translation: "嘴巴" },
  hand: { pos: "名詞", translation: "手" },
  hands: { pos: "名詞", translation: "手" },
  arm: { pos: "名詞", translation: "手臂" },
  arms: { pos: "名詞", translation: "手臂" },
  leg: { pos: "名詞", translation: "腿" },
  legs: { pos: "名詞", translation: "腿" },
  foot: { pos: "名詞", translation: "腳" },
  feet: { pos: "名詞", translation: "腳" },
  neck: { pos: "名詞", translation: "脖子" },
  finger: { pos: "名詞", translation: "手指" },
  toe: { pos: "名詞", translation: "腳趾" },

  // Foods
  food: { pos: "名詞", translation: "食物" },
  water: { pos: "名詞", translation: "水" },
  milk: { pos: "名詞", translation: "牛奶" },
  juice: { pos: "名詞", translation: "果汁" },
  bread: { pos: "名詞", translation: "麵包" },
  cereal: { pos: "名詞", translation: "麥片" },
  pizza: { pos: "名詞", translation: "披薩" },
  sandwich: { pos: "名詞", translation: "三明治" },
  apple: { pos: "名詞", translation: "蘋果" },
  apples: { pos: "名詞", translation: "蘋果" },
  banana: { pos: "名詞", translation: "香蕉" },
  bananas: { pos: "名詞", translation: "香蕉" },
  orange: { pos: "名詞", translation: "橙子" },
  carrot: { pos: "名詞", translation: "胡蘿蔔" },
  carrots: { pos: "名詞", translation: "胡蘿蔔" },
  egg: { pos: "名詞", translation: "雞蛋" },
  eggs: { pos: "名詞", translation: "雞蛋" },
  vegetable: { pos: "名詞", translation: "蔬菜" },
  vegetables: { pos: "名詞", translation: "蔬菜" },
  noodle: { pos: "名詞", translation: "麵條" },
  noodles: { pos: "名詞", translation: "麵條" },
  oatmeal: { pos: "名詞", translation: "燕麥片" },
  cookie: { pos: "名詞", translation: "餅乾" },
  cake: { pos: "名詞", translation: "蛋糕" },

  // Clothing
  shirt: { pos: "名詞", translation: "襯衫" },
  pants: { pos: "名詞", translation: "褲子" },
  skirt: { pos: "名詞", translation: "裙子" },
  dress: { pos: "名詞", translation: "連衣裙" },
  shoes: { pos: "名詞", translation: "鞋子" },
  sock: { pos: "名詞", translation: "襪子" },
  socks: { pos: "名詞", translation: "襪子" },
  jacket: { pos: "名詞", translation: "外套" },
  coat: { pos: "名詞", translation: "大衣" },
  hat: { pos: "名詞", translation: "帽子" },
  mittens: { pos: "名詞", translation: "連指手套" },
  glove: { pos: "名詞", translation: "手套" },
  gloves: { pos: "名詞", translation: "手套" },

  // Toys and objects
  ball: { pos: "名詞", translation: "球" },
  toy: { pos: "名詞", translation: "玩具" },
  doll: { pos: "名詞", translation: "娃娃" },
  car: { pos: "名詞", translation: "汽車" },
  bike: { pos: "名詞", translation: "自行車" },
  bicycle: { pos: "名詞", translation: "自行車" },
  kite: { pos: "名詞", translation: "風箏" },
  balloon: { pos: "名詞", translation: "氣球" },
  bottle: { pos: "名詞", translation: "瓶子" },
  box: { pos: "名詞", translation: "盒子" },
  bag: { pos: "名詞", translation: "袋子" },
  cup: { pos: "名詞", translation: "杯子" },
  plate: { pos: "名詞", translation: "盤子" },
  spoon: { pos: "名詞", translation: "湯匙" },
  fork: { pos: "名詞", translation: "叉子" },
  knife: { pos: "名詞", translation: "刀" },
  bowl: { pos: "名詞", translation: "碗" },
  umbrella: { pos: "名詞", translation: "雨傘" },
  key: { pos: "名詞", translation: "鑰匙" },
  glue: { pos: "名詞", translation: "膠水" },
  crayon: { pos: "名詞", translation: "蠟筆" },
  scissors: { pos: "名詞", translation: "剪刀" },
  picture: { pos: "名詞", translation: "圖片" },
  photo: { pos: "名詞", translation: "照片" },

  // Nature
  tree: { pos: "名詞", translation: "樹" },
  flower: { pos: "名詞", translation: "花" },
  grass: { pos: "名詞", translation: "草" },
  leaf: { pos: "名詞", translation: "葉子" },
  leaves: { pos: "名詞", translation: "葉子" },
  plant: { pos: "名詞", translation: "植物" },
  garden: { pos: "名詞", translation: "花園" },
  sky: { pos: "名詞", translation: "天空" },
  cloud: { pos: "名詞", translation: "雲" },
  clouds: { pos: "名詞", translation: "雲" },
  rain: { pos: "名詞", translation: "雨" },
  snow: { pos: "名詞", translation: "雪" },
  wind: { pos: "名詞", translation: "風" },
  sun: { pos: "名詞", translation: "太陽" },
  moon: { pos: "名詞", translation: "月亮" },
  star: { pos: "名詞", translation: "星星" },
  stars: { pos: "名詞", translation: "星星" },
  rainbow: { pos: "名詞", translation: "彩虹" },
  day: { pos: "名詞", translation: "天" },
  night: { pos: "名詞", translation: "夜晚" },
  time: { pos: "名詞", translation: "時間" },
  year: { pos: "名詞", translation: "年" },
  month: { pos: "名詞", translation: "月" },
  week: { pos: "名詞", translation: "週" },
  morning: { pos: "名詞", translation: "早上" },
  afternoon: { pos: "名詞", translation: "下午" },
  evening: { pos: "名詞", translation: "傍晚" },
  today: { pos: "名詞", translation: "今天" },
  tomorrow: { pos: "名詞", translation: "明天" },
  yesterday: { pos: "名詞", translation: "昨天" },
  weekend: { pos: "名詞", translation: "週末" },

  // Seasons
  spring: { pos: "名詞", translations: ["春天", "泉水", "彈簧"] },
  summer: { pos: "名詞", translation: "夏天" },
  autumn: { pos: "名詞", translation: "秋天" },
  fall: { pos: "名詞", translation: "秋天" },
  winter: { pos: "名詞", translation: "冬天" },
  season: { pos: "名詞", translation: "季節" },

  // Weather
  weather: { pos: "名詞", translation: "天氣" },
  sunny: { pos: "形容詞", translation: "晴朗的" },
  cloudy: { pos: "形容詞", translation: "多雲的" },
  rainy: { pos: "形容詞", translation: "下雨的" },
  snowy: { pos: "形容詞", translation: "下雪的" },
  windy: { pos: "形容詞", translation: "多風的" },
  stormy: { pos: "形容詞", translation: "暴風雨的" },
  mat: { pos: "名詞", translation: "墊子" },

  // Adjectives - Size and Measurement
  big: { pos: "形容詞", translation: "大的" },
  large: { pos: "形容詞", translation: "大的" },
  small: { pos: "形容詞", translation: "小的" },
  little: { pos: "形容詞", translation: "小的" },
  tiny: { pos: "形容詞", translation: "極小的" },
  tall: { pos: "形容詞", translation: "高的" },
  short: { pos: "形容詞", translation: "矮的" },
  long: { pos: "形容詞", translation: "長的" },
  wide: { pos: "形容詞", translation: "寬的" },
  narrow: { pos: "形容詞", translation: "窄的" },
  thick: { pos: "形容詞", translation: "厚的" },
  thin: { pos: "形容詞", translation: "薄的" },
  heavy: { pos: "形容詞", translation: "重的" },
  light: { pos: "名詞/形容詞", translations: ["光", "輕的", "燈"] },
  full: { pos: "形容詞", translation: "滿的" },
  empty: { pos: "形容詞", translation: "空的" },

  // Adjectives - Quality and Appearance
  good: { pos: "形容詞", translation: "好的" },
  bad: { pos: "形容詞", translation: "壞的" },
  nice: { pos: "形容詞", translation: "好的" },
  pretty: { pos: "形容詞", translation: "漂亮的" },
  beautiful: { pos: "形容詞", translation: "美麗的" },
  ugly: { pos: "形容詞", translation: "醜的" },
  clean: { pos: "形容詞", translation: "乾淨的" },
  dirty: { pos: "形容詞", translation: "髒的" },
  wet: { pos: "形容詞", translation: "濕的" },
  dry: { pos: "形容詞", translation: "乾的" },
  soft: { pos: "形容詞", translation: "軟的" },
  hard: { pos: "形容詞", translations: ["硬的", "困難的"] },
  smooth: { pos: "形容詞", translation: "光滑的" },
  rough: { pos: "形容詞", translation: "粗糙的" },
  shiny: { pos: "形容詞", translation: "閃亮的" },
  bright: { pos: "形容詞", translation: "明亮的" },
  dark: { pos: "形容詞", translation: "黑暗的" },

  // Adjectives - Temperature and Texture
  hot: { pos: "形容詞", translation: "熱的" },
  warm: { pos: "形容詞", translation: "溫暖的" },
  cool: { pos: "形容詞", translation: "涼爽的" },
  cold: { pos: "形容詞", translation: "冷的" },
  chilly: { pos: "形容詞", translation: "寒冷的" },
  frozen: { pos: "形容詞", translation: "冰凍的" },
  fluffy: { pos: "形容詞", translation: "蓬鬆的" },
  bumpy: { pos: "形容詞", translation: "顛簸的" },

  // Adjectives - Age
  new: { pos: "形容詞", translation: "新的" },
  old: { pos: "形容詞", translations: ["舊的", "年老的", "老的"] },
  young: { pos: "形容詞", translation: "年輕的" },

  // Adjectives - Feelings and Emotions
  happy: { pos: "形容詞", translation: "快樂的" },
  sad: { pos: "形容詞", translation: "傷心的" },
  excited: { pos: "形容詞", translation: "興奮的" },
  angry: { pos: "形容詞", translation: "生氣的" },
  mad: { pos: "形容詞", translation: "瘋狂的" },
  scared: { pos: "形容詞", translation: "害怕的" },
  afraid: { pos: "形容詞", translation: "害怕的" },
  worried: { pos: "形容詞", translation: "擔心的" },
  nervous: { pos: "形容詞", translation: "緊張的" },
  tired: { pos: "形容詞", translation: "累的" },
  sleepy: { pos: "形容詞", translation: "困的" },
  hungry: { pos: "形容詞", translation: "餓的" },
  thirsty: { pos: "形容詞", translation: "渴的" },
  sick: { pos: "形容詞", translation: "生病的" },
  well: { pos: "形容詞", translation: "健康的" },
  healthy: { pos: "形容詞", translation: "健康的" },
  proud: { pos: "形容詞", translation: "驕傲的" },
  shy: { pos: "形容詞", translation: "害羞的" },
  brave: { pos: "形容詞", translation: "勇敢的" },
  kind: { pos: "形容詞", translation: "善良的" },
  mean: { pos: "形容詞", translation: "刻薄的" },
  polite: { pos: "形容詞", translation: "有禮貌的" },
  rude: { pos: "形容詞", translation: "粗魯的" },

  // Adjectives - Difficulty and Speed
  easy: { pos: "形容詞", translation: "容易的" },
  difficult: { pos: "形容詞", translation: "困難的" },
  fast: { pos: "形容詞", translation: "快的" },
  quick: { pos: "形容詞", translation: "快速的" },
  slow: { pos: "形容詞", translation: "慢的" },
  loud: { pos: "形容詞", translation: "大聲的" },
  quiet: { pos: "形容詞", translation: "安靜的" },
  noisy: { pos: "形容詞", translation: "吵鬧的" },
  silent: { pos: "形容詞", translation: "寂靜的" },

  // Adjectives - Quantity
  many: { pos: "形容詞", translation: "許多" },
  much: { pos: "形容詞", translation: "許多" },
  few: { pos: "形容詞", translation: "少數" },
  some: { pos: "形容詞", translation: "一些" },
  all: { pos: "形容詞", translation: "所有的" },
  every: { pos: "形容詞", translation: "每個" },
  each: { pos: "形容詞", translation: "每個" },

  // Prepositions and Position Words
  in: { pos: "介系詞", translation: "在裡面" },
  on: { pos: "介系詞", translation: "在上面" },
  at: { pos: "介系詞", translation: "在" },
  to: { pos: "介系詞", translation: "到" },
  from: { pos: "介系詞", translation: "從" },
  with: { pos: "介系詞", translation: "和" },
  without: { pos: "介系詞", translation: "沒有" },
  for: { pos: "介系詞", translation: "為了" },
  of: { pos: "介系詞", translation: "的" },
  about: { pos: "介系詞", translation: "關於" },
  above: { pos: "介系詞", translation: "在上方" },
  below: { pos: "介系詞", translation: "在下方" },
  under: { pos: "介系詞", translation: "在下面" },
  over: { pos: "介系詞", translation: "在上面" },
  behind: { pos: "介系詞", translation: "在後面" },
  front: { pos: "名詞", translation: "前面" },
  back: { pos: "名詞", translation: "後面" },
  next: { pos: "形容詞", translation: "下一個" },
  between: { pos: "介系詞", translation: "在之間" },
  beside: { pos: "介系詞", translation: "在旁邊" },
  near: { pos: "介系詞", translation: "靠近" },
  far: { pos: "形容詞", translation: "遠的" },
  inside: { pos: "介系詞", translation: "在裡面" },
  outside: { pos: "介系詞", translation: "在外面" },
  up: { pos: "副詞", translation: "向上" },
  down: { pos: "副詞", translation: "向下" },
  left: { pos: "名詞", translation: "左邊" },
  right: { pos: "名詞", translation: "右邊" },
  top: { pos: "名詞", translation: "頂部" },
  bottom: { pos: "名詞", translation: "底部" },
  middle: { pos: "名詞", translation: "中間" },
  around: { pos: "介系詞", translation: "在周圍" },
  through: { pos: "介系詞", translation: "穿過" },
  into: { pos: "介系詞", translation: "進入" },
  out: { pos: "副詞", translation: "出去" },
  off: { pos: "副詞", translation: "離開" },
  along: { pos: "介系詞", translation: "沿著" },
  across: { pos: "介系詞", translation: "橫過" },

  // Numbers
  zero: { pos: "數詞", translation: "零" },
  one: { pos: "數詞", translation: "一" },
  two: { pos: "數詞", translation: "二" },
  three: { pos: "數詞", translation: "三" },
  four: { pos: "數詞", translation: "四" },
  five: { pos: "數詞", translation: "五" },
  six: { pos: "數詞", translation: "六" },
  seven: { pos: "數詞", translation: "七" },
  eight: { pos: "數詞", translation: "八" },
  nine: { pos: "數詞", translation: "九" },
  ten: { pos: "數詞", translation: "十" },
  eleven: { pos: "數詞", translation: "十一" },
  twelve: { pos: "數詞", translation: "十二" },
  thirteen: { pos: "數詞", translation: "十三" },
  fourteen: { pos: "數詞", translation: "十四" },
  fifteen: { pos: "數詞", translation: "十五" },
  sixteen: { pos: "數詞", translation: "十六" },
  seventeen: { pos: "數詞", translation: "十七" },
  eighteen: { pos: "數詞", translation: "十八" },
  nineteen: { pos: "數詞", translation: "十九" },
  twenty: { pos: "數詞", translation: "二十" },
  thirty: { pos: "數詞", translation: "三十" },
  forty: { pos: "數詞", translation: "四十" },
  fifty: { pos: "數詞", translation: "五十" },
  hundred: { pos: "數詞", translation: "一百" },
  first: { pos: "數詞", translation: "第一" },
  second: { pos: "數詞", translation: "第二" },
  third: { pos: "數詞", translation: "第三" },
  last: { pos: "形容詞", translation: "最後的" },

  // Shapes
  shape: { pos: "名詞", translation: "形狀" },
  circle: { pos: "名詞", translation: "圓形" },
  round: { pos: "形容詞", translation: "圓的" },
  square: { pos: "名詞", translation: "正方形" },
  rectangle: { pos: "名詞", translation: "長方形" },
  triangle: { pos: "名詞", translation: "三角形" },
  oval: { pos: "名詞", translation: "橢圓形" },
  heart: { pos: "名詞", translation: "心形" },
  diamond: { pos: "名詞", translation: "菱形" },
  line: { pos: "名詞", translation: "線" },
  corner: { pos: "名詞", translation: "角落" },
  side: { pos: "名詞", translation: "邊" },

  // Colors
  color: { pos: "名詞", translation: "顏色" },
  red: { pos: "形容詞", translation: "紅色" },
  blue: { pos: "形容詞", translation: "藍色" },
  green: { pos: "形容詞", translation: "綠色" },
  yellow: { pos: "形容詞", translation: "黃色" },
  black: { pos: "形容詞", translation: "黑色" },
  white: { pos: "形容詞", translation: "白色" },
  brown: { pos: "形容詞", translation: "棕色" },
  orange: { pos: "形容詞", translation: "橙色" },
  purple: { pos: "形容詞", translation: "紫色" },
  pink: { pos: "形容詞", translation: "粉紅色" },
  gray: { pos: "形容詞", translation: "灰色" },
  grey: { pos: "形容詞", translation: "灰色" },
  gold: { pos: "形容詞", translation: "金色" },
  silver: { pos: "形容詞", translation: "銀色" },

  // Question Words
  what: { pos: "代名詞", translation: "什麼" },
  when: { pos: "副詞", translation: "什麼時候" },
  where: { pos: "副詞", translation: "哪裡" },
  who: { pos: "代名詞", translation: "誰" },
  whom: { pos: "代名詞", translation: "誰" },
  whose: { pos: "代名詞", translation: "誰的" },
  why: { pos: "副詞", translation: "為什麼" },
  how: { pos: "副詞", translation: "怎麼樣" },
  which: { pos: "代名詞", translation: "哪一個" },

  // Greetings and Common Phrases
  hello: { pos: "感嘆詞", translation: "你好" },
  hi: { pos: "感嘆詞", translation: "嗨" },
  goodbye: { pos: "感嘆詞", translation: "再見" },
  bye: { pos: "感嘆詞", translation: "再見" },
  thanks: { pos: "名詞", translation: "謝謝" },
  thank: { pos: "動詞", translation: "感謝" },
  please: { pos: "副詞", translation: "請" },
  sorry: { pos: "形容詞", translation: "對不起" },
  excuse: { pos: "動詞", translation: "原諒" },
  welcome: { pos: "形容詞", translation: "歡迎" },
  yes: { pos: "副詞", translation: "是" },
  no: { pos: "副詞", translation: "不" },
  okay: { pos: "形容詞", translation: "好的" },
  ok: { pos: "形容詞", translation: "好的" },
  fine: { pos: "形容詞", translation: "好的" },

  // Adverbs
  here: { pos: "副詞", translation: "這裡" },
  there: { pos: "副詞", translation: "那裡" },
  now: { pos: "副詞", translation: "現在" },
  then: { pos: "副詞", translation: "然後" },
  always: { pos: "副詞", translation: "總是" },
  never: { pos: "副詞", translation: "從不" },
  sometimes: { pos: "副詞", translation: "有時候" },
  often: { pos: "副詞", translation: "經常" },
  usually: { pos: "副詞", translation: "通常" },
  again: { pos: "副詞", translation: "再一次" },
  too: { pos: "副詞", translation: "也" },
  also: { pos: "副詞", translation: "也" },
  very: { pos: "副詞", translation: "非常" },
  really: { pos: "副詞", translation: "真的" },
  just: { pos: "副詞", translation: "只是" },
  only: { pos: "副詞", translation: "只有" },
  almost: { pos: "副詞", translation: "幾乎" },
  enough: { pos: "副詞", translation: "足夠" },
  together: { pos: "副詞", translation: "一起" },
  alone: { pos: "副詞", translation: "單獨地" },

  // Words with multiple meanings (Note: some words already defined above with primary meaning)
  bank: { pos: "名詞", translations: ["銀行", "河岸"] },
  bat: { pos: "名詞", translations: ["蝙蝶", "球棒"] },

  // Additional Animals
  mouse: { pos: "名詞", translation: "老鼠" },
  rat: { pos: "名詞", translation: "老鼠" },
  hamster: { pos: "名詞", translation: "倉鼠" },
  snake: { pos: "名詞", translation: "蛇" },
  turtle: { pos: "名詞", translation: "烏龜" },
  owl: { pos: "名詞", translation: "貓頭鷹" },
  penguin: { pos: "名詞", translation: "企鵝" },
  dolphin: { pos: "名詞", translation: "海豚" },
  whale: { pos: "名詞", translation: "鯨魚" },
  shark: { pos: "名詞", translation: "鯊魚" },
  bee: { pos: "名詞", translation: "蜜蜂" },
  ant: { pos: "名詞", translation: "螞蟻" },
  ladybug: { pos: "名詞", translation: "瓢蟲" },
  worm: { pos: "名詞", translation: "蟲" },
  insect: { pos: "名詞", translation: "昆蟲" },
  puppy: { pos: "名詞", translation: "小狗" },
  kitten: { pos: "名詞", translation: "小貓" },
  chick: { pos: "名詞", translation: "小雞" },
  calf: { pos: "名詞", translation: "小牛" },
  lamb: { pos: "名詞", translation: "小羊" },
  monkey: { pos: "名詞", translation: "猴子" },
  giraffe: { pos: "名詞", translation: "長頸鹿" },
  zebra: { pos: "名詞", translation: "斑馬" },
  deer: { pos: "名詞", translation: "鹿" },
  squirrel: { pos: "名詞", translation: "松鼠" },
  goat: { pos: "名詞", translation: "山羊" },
  fox: { pos: "名詞", translation: "狐狸" },
  wolf: { pos: "名詞", translation: "狼" },
  camel: { pos: "名詞", translation: "駱駝" },
  panda: { pos: "名詞", translation: "熊貓" },
  koala: { pos: "名詞", translation: "無尾熊" },
  seal: { pos: "名詞", translation: "海豹" },
  crab: { pos: "名詞", translation: "螃蟹" },
  lobster: { pos: "名詞", translation: "龍蝦" },
  octopus: { pos: "名詞", translation: "章魚" },
  starfish: { pos: "名詞", translation: "海星" },
  jellyfish: { pos: "名詞", translation: "水母" },
  parrot: { pos: "名詞", translation: "鸚鵡" },
  eagle: { pos: "名詞", translation: "老鷹" },
  swan: { pos: "名詞", translation: "天鵝" },
  goose: { pos: "名詞", translation: "鵝" },
  turkey: { pos: "名詞", translation: "火雞" },
  peacock: { pos: "名詞", translation: "孔雀" },
  lizard: { pos: "名詞", translation: "蜥蜴" },
  crocodile: { pos: "名詞", translation: "鱷魚" },
  alligator: { pos: "名詞", translation: "短吻鱷" },
  dinosaur: { pos: "名詞", translation: "恐龍" },

  // Additional Family & People
  mum: { pos: "名詞", translation: "媽媽" },
  parent: { pos: "名詞", translation: "父母" },
  parents: { pos: "名詞", translation: "父母" },
  nephew: { pos: "名詞", translation: "侄子" },
  niece: { pos: "名詞", translation: "侄女" },
  twins: { pos: "名詞", translation: "雙胞胎" },
  neighbor: { pos: "名詞", translation: "鄰居" },
  classmate: { pos: "名詞", translation: "同學" },
  nurse: { pos: "名詞", translation: "護士" },
  dentist: { pos: "名詞", translation: "牙醫" },
  veterinarian: { pos: "名詞", translation: "獸醫" },
  vet: { pos: "名詞", translation: "獸醫" },
  pilot: { pos: "名詞", translation: "飛行員" },
  police: { pos: "名詞", translation: "警察" },
  officer: { pos: "名詞", translation: "警官" },
  scientist: { pos: "名詞", translation: "科學家" },
  chef: { pos: "名詞", translation: "廚師" },
  cook: { pos: "名詞/動詞", translations: ["廚師", "烹飪"] },
  baker: { pos: "名詞", translation: "麵包師" },
  astronaut: { pos: "名詞", translation: "太空人" },
  engineer: { pos: "名詞", translation: "工程師" },
  dancer: { pos: "名詞", translation: "舞者" },
  singer: { pos: "名詞", translation: "歌手" },
  actor: { pos: "名詞", translation: "演員" },
  actress: { pos: "名詞", translation: "女演員" },

  // Additional Foods & Drinks
  rice: { pos: "名詞", translation: "米飯" },
  soup: { pos: "名詞", translation: "湯" },
  salad: { pos: "名詞", translation: "沙拉" },
  meat: { pos: "名詞", translation: "肉" },
  chicken: { pos: "名詞", translation: "雞肉" },
  beef: { pos: "名詞", translation: "牛肉" },
  pork: { pos: "名詞", translation: "豬肉" },
  fish: { pos: "名詞", translation: "魚肉" },
  cheese: { pos: "名詞", translation: "乳酪" },
  butter: { pos: "名詞", translation: "黃油" },
  yogurt: { pos: "名詞", translation: "優格" },
  ice: { pos: "名詞", translation: "冰" },
  cream: { pos: "名詞", translation: "奶油" },
  sugar: { pos: "名詞", translation: "糖" },
  salt: { pos: "名詞", translation: "鹽" },
  pepper: { pos: "名詞", translation: "胡椒" },
  honey: { pos: "名詞", translation: "蜂蜜" },
  jam: { pos: "名詞", translation: "果醬" },
  peanut: { pos: "名詞", translation: "花生" },
  nut: { pos: "名詞", translation: "堅果" },
  grape: { pos: "名詞", translation: "葡萄" },
  grapes: { pos: "名詞", translation: "葡萄" },
  strawberry: { pos: "名詞", translation: "草莓" },
  watermelon: { pos: "名詞", translation: "西瓜" },
  melon: { pos: "名詞", translation: "瓜" },
  peach: { pos: "名詞", translation: "桃子" },
  pear: { pos: "名詞", translation: "梨" },
  cherry: { pos: "名詞", translation: "櫻桃" },
  lemon: { pos: "名詞", translation: "檸檬" },
  lime: { pos: "名詞", translation: "萊姆" },
  pineapple: { pos: "名詞", translation: "鳳梨" },
  mango: { pos: "名詞", translation: "芒果" },
  kiwi: { pos: "名詞", translation: "奇異果" },
  coconut: { pos: "名詞", translation: "椰子" },
  tomato: { pos: "名詞", translation: "番茄" },
  potato: { pos: "名詞", translation: "馬鈴薯" },
  onion: { pos: "名詞", translation: "洋蔥" },
  lettuce: { pos: "名詞", translation: "生菜" },
  cucumber: { pos: "名詞", translation: "黃瓜" },
  corn: { pos: "名詞", translation: "玉米" },
  pumpkin: { pos: "名詞", translation: "南瓜" },
  bean: { pos: "名詞", translation: "豆子" },
  beans: { pos: "名詞", translation: "豆子" },
  pea: { pos: "名詞", translation: "豌豆" },
  peas: { pos: "名詞", translation: "豌豆" },
  cabbage: { pos: "名詞", translation: "高麗菜" },
  broccoli: { pos: "名詞", translation: "花椰菜" },
  mushroom: { pos: "名詞", translation: "蘑菇" },
  tea: { pos: "名詞", translation: "茶" },
  coffee: { pos: "名詞", translation: "咖啡" },
  soda: { pos: "名詞", translation: "汽水" },
  candy: { pos: "名詞", translation: "糖果" },
  chocolate: { pos: "名詞", translation: "巧克力" },
  popcorn: { pos: "名詞", translation: "爆米花" },
  donut: { pos: "名詞", translation: "甜甜圈" },
  waffle: { pos: "名詞", translation: "鬆餅" },
  pancake: { pos: "名詞", translation: "煎餅" },
  pretzel: { pos: "名詞", translation: "椒鹽卷餅" },
  cracker: { pos: "名詞", translation: "餅乾" },
  chip: { pos: "名詞", translation: "薯片" },
  chips: { pos: "名詞", translation: "薯片" },
  hamburger: { pos: "名詞", translation: "漢堡" },
  hotdog: { pos: "名詞", translation: "熱狗" },
  taco: { pos: "名詞", translation: "墨西哥捲餅" },
  burrito: { pos: "名詞", translation: "墨西哥捲餅" },
  spaghetti: { pos: "名詞", translation: "義大利麵" },
  pasta: { pos: "名詞", translation: "義大利麵" },

  // Additional Verbs
  stop: { pos: "動詞", translation: "停止" },
  start: { pos: "動詞", translation: "開始" },
  begin: { pos: "動詞", translation: "開始" },
  finish: { pos: "動詞", translation: "完成" },
  end: { pos: "動詞", translation: "結束" },
  try: { pos: "動詞", translation: "嘗試" },
  use: { pos: "動詞", translation: "使用" },
  wait: { pos: "動詞", translation: "等待" },
  stay: { pos: "動詞", translation: "停留" },
  leave: { pos: "動詞", translation: "離開" },
  arrive: { pos: "動詞", translation: "到達" },
  return: { pos: "動詞", translation: "返回" },
  visit: { pos: "動詞", translation: "拜訪" },
  travel: { pos: "動詞", translation: "旅行" },
  move: { pos: "動詞", translation: "移動" },
  turn: { pos: "動詞", translation: "轉向" },
  spin: { pos: "動詞", translation: "旋轉" },
  roll: { pos: "動詞", translation: "滾動" },
  slide: { pos: "動詞", translation: "滑動" },
  swing: { pos: "動詞", translation: "擺動" },
  fly: { pos: "動詞", translation: "飛" },
  swim: { pos: "動詞", translation: "游泳" },
  dive: { pos: "動詞", translation: "跳水" },
  float: { pos: "動詞", translation: "漂浮" },
  sink: { pos: "動詞", translation: "下沉" },
  melt: { pos: "動詞", translation: "融化" },
  freeze: { pos: "動詞", translation: "結冰" },
  boil: { pos: "動詞", translation: "煮沸" },
  bake: { pos: "動詞", translation: "烘烤" },
  fry: { pos: "動詞", translation: "油炸" },
  mix: { pos: "動詞", translation: "混合" },
  stir: { pos: "動詞", translation: "攪拌" },
  pour: { pos: "動詞", translation: "倒" },
  fill: { pos: "動詞", translation: "填滿" },
  spill: { pos: "動詞", translation: "灑出" },
  drop: { pos: "動詞", translation: "掉落" },
  pick: { pos: "動詞", translation: "撿起" },
  lift: { pos: "動詞", translation: "舉起" },
  raise: { pos: "動詞", translation: "抬起" },
  lower: { pos: "動詞", translation: "降低" },
  bend: { pos: "動詞", translation: "彎曲" },
  stretch: { pos: "動詞", translation: "伸展" },
  reach: { pos: "動詞", translation: "到達" },
  touch: { pos: "動詞", translation: "觸摸" },
  grab: { pos: "動詞", translation: "抓住" },
  squeeze: { pos: "動詞", translation: "擠壓" },
  pinch: { pos: "動詞", translation: "捏" },
  tickle: { pos: "動詞", translation: "搔癢" },
  hug: { pos: "動詞", translation: "擁抱" },
  kiss: { pos: "動詞", translation: "親吻" },
  wave: { pos: "動詞", translation: "揮手" },
  clap: { pos: "動詞", translation: "拍手" },
  point: { pos: "動詞", translation: "指" },
  nod: { pos: "動詞", translation: "點頭" },
  shake: { pos: "動詞", translation: "搖動" },
  wiggle: { pos: "動詞", translation: "扭動" },
  kick: { pos: "動詞", translation: "踢" },
  hit: { pos: "動詞", translation: "打" },
  slap: { pos: "動詞", translation: "拍打" },
  bite: { pos: "動詞", translation: "咬" },
  chew: { pos: "動詞", translation: "咀嚼" },
  swallow: { pos: "動詞", translation: "吞嚥" },
  taste: { pos: "動詞", translation: "品嚐" },
  smell: { pos: "動詞", translation: "聞" },
  sniff: { pos: "動詞", translation: "嗅" },
  breathe: { pos: "動詞", translation: "呼吸" },
  cough: { pos: "動詞", translation: "咳嗽" },
  sneeze: { pos: "動詞", translation: "打噴嚏" },
  yawn: { pos: "動詞", translation: "打哈欠" },
  blink: { pos: "動詞", translation: "眨眼" },
  wink: { pos: "動詞", translation: "眨眼" },
  stare: { pos: "動詞", translation: "凝視" },
  peek: { pos: "動詞", translation: "偷看" },
  hide: { pos: "動詞", translation: "躲藏" },
  seek: { pos: "動詞", translation: "尋找" },
  search: { pos: "動詞", translation: "搜尋" },
  discover: { pos: "動詞", translation: "發現" },
  explore: { pos: "動詞", translation: "探索" },
  study: { pos: "動詞", translation: "學習" },
  learn: { pos: "動詞", translation: "學習" },
  teach: { pos: "動詞", translation: "教導" },
  practice: { pos: "動詞", translation: "練習" },
  remember: { pos: "動詞", translation: "記得" },
  forget: { pos: "動詞", translation: "忘記" },
  understand: { pos: "動詞", translation: "理解" },
  count: { pos: "動詞", translation: "計數" },
  add: { pos: "動詞", translation: "加" },
  subtract: { pos: "動詞", translation: "減" },
  multiply: { pos: "動詞", translation: "乘" },
  divide: { pos: "動詞", translation: "除" },
  measure: { pos: "動詞", translation: "測量" },
  weigh: { pos: "動詞", translation: "稱重" },
  compare: { pos: "動詞", translation: "比較" },
  match: { pos: "動詞", translation: "配對" },
  sort: { pos: "動詞", translation: "分類" },
  arrange: { pos: "動詞", translation: "安排" },
  organize: { pos: "動詞", translation: "組織" },
  collect: { pos: "動詞", translation: "收集" },
  gather: { pos: "動詞", translation: "聚集" },
  scatter: { pos: "動詞", translation: "散開" },
  spread: { pos: "動詞", translation: "展開" },
  cover: { pos: "動詞", translation: "覆蓋" },
  uncover: { pos: "動詞", translation: "揭開" },
  wrap: { pos: "動詞", translation: "包裹" },
  unwrap: { pos: "動詞", translation: "拆開" },
  tie: { pos: "動詞", translation: "綁" },
  untie: { pos: "動詞", translation: "解開" },
  lock: { pos: "動詞", translation: "鎖" },
  unlock: { pos: "動詞", translation: "解鎖" },
  knock: { pos: "動詞", translation: "敲" },
  ring: { pos: "動詞", translation: "按鈴" },
  press: { pos: "動詞", translation: "按" },
  click: { pos: "動詞", translation: "點擊" },
  tap: { pos: "動詞", translation: "輕拍" },
  rub: { pos: "動詞", translation: "擦" },
  wipe: { pos: "動詞", translation: "擦拭" },
  scrub: { pos: "動詞", translation: "刷洗" },
  sweep: { pos: "動詞", translation: "掃" },
  mop: { pos: "動詞", translation: "拖" },
  dust: { pos: "動詞", translation: "除塵" },
  polish: { pos: "動詞", translation: "擦亮" },
  vacuum: { pos: "動詞", translation: "吸塵" },
  fold: { pos: "動詞", translation: "摺疊" },
  unfold: { pos: "動詞", translation: "展開" },
  iron: { pos: "動詞", translation: "熨燙" },
  hang: { pos: "動詞", translation: "掛" },
  wear: { pos: "動詞", translation: "穿戴" },
  dress: { pos: "動詞", translation: "穿衣" },
  change: { pos: "動詞", translation: "改變" },
  grow: { pos: "動詞", translation: "生長" },
  shrink: { pos: "動詞", translation: "縮小" },
  bloom: { pos: "動詞", translation: "開花" },
  wither: { pos: "動詞", translation: "枯萎" },
  plant: { pos: "動詞", translation: "種植" },
  water: { pos: "動詞", translation: "澆水" },
  dig: { pos: "動詞", translation: "挖" },
  bury: { pos: "動詞", translation: "埋" },

  // Additional Body Parts
  shoulder: { pos: "名詞", translation: "肩膀" },
  back: { pos: "名詞", translation: "背" },
  chest: { pos: "名詞", translation: "胸" },
  stomach: { pos: "名詞", translation: "肚子" },
  belly: { pos: "名詞", translation: "腹部" },
  knee: { pos: "名詞", translation: "膝蓋" },
  elbow: { pos: "名詞", translation: "手肘" },
  wrist: { pos: "名詞", translation: "手腕" },
  ankle: { pos: "名詞", translation: "腳踝" },
  thumb: { pos: "名詞", translation: "拇指" },
  tongue: { pos: "名詞", translation: "舌頭" },
  tooth: { pos: "名詞", translation: "牙齒" },
  teeth: { pos: "名詞", translation: "牙齒" },
  hair: { pos: "名詞", translation: "頭髮" },
  skin: { pos: "名詞", translation: "皮膚" },
  bone: { pos: "名詞", translation: "骨頭" },
  muscle: { pos: "名詞", translation: "肌肉" },
  heart: { pos: "名詞", translation: "心臟" },
  brain: { pos: "名詞", translation: "大腦" },
  blood: { pos: "名詞", translation: "血液" },
  cheek: { pos: "名詞", translation: "臉頰" },
  chin: { pos: "名詞", translation: "下巴" },
  forehead: { pos: "名詞", translation: "額頭" },
  eyebrow: { pos: "名詞", translation: "眉毛" },
  eyelash: { pos: "名詞", translation: "睫毛" },
  eyelid: { pos: "名詞", translation: "眼皮" },
  lip: { pos: "名詞", translation: "嘴唇" },
  lips: { pos: "名詞", translation: "嘴唇" },

  // Additional Clothing
  clothing: { pos: "名詞", translation: "衣服" },
  clothes: { pos: "名詞", translation: "衣服" },
  uniform: { pos: "名詞", translation: "制服" },
  sweater: { pos: "名詞", translation: "毛衣" },
  sweatshirt: { pos: "名詞", translation: "運動衫" },
  hoodie: { pos: "名詞", translation: "連帽衫" },
  cardigan: { pos: "名詞", translation: "開襟毛衣" },
  vest: { pos: "名詞", translation: "背心" },
  shorts: { pos: "名詞", translation: "短褲" },
  jeans: { pos: "名詞", translation: "牛仔褲" },
  leggings: { pos: "名詞", translation: "緊身褲" },
  pajamas: { pos: "名詞", translation: "睡衣" },
  robe: { pos: "名詞", translation: "浴袍" },
  scarf: { pos: "名詞", translation: "圍巾" },
  tie: { pos: "名詞", translation: "領帶" },
  belt: { pos: "名詞", translation: "皮帶" },
  button: { pos: "名詞", translation: "鈕扣" },
  zipper: { pos: "名詞", translation: "拉鍊" },
  pocket: { pos: "名詞", translation: "口袋" },
  sleeve: { pos: "名詞", translation: "袖子" },
  collar: { pos: "名詞", translation: "領子" },
  shoe: { pos: "名詞", translation: "鞋子" },
  boot: { pos: "名詞", translation: "靴子" },
  boots: { pos: "名詞", translation: "靴子" },
  sandal: { pos: "名詞", translation: "涼鞋" },
  sandals: { pos: "名詞", translation: "涼鞋" },
  sneaker: { pos: "名詞", translation: "運動鞋" },
  sneakers: { pos: "名詞", translation: "運動鞋" },
  slipper: { pos: "名詞", translation: "拖鞋" },
  slippers: { pos: "名詞", translation: "拖鞋" },

  // School & Learning
  classroom: { pos: "名詞", translation: "教室" },
  lesson: { pos: "名詞", translation: "課程" },
  homework: { pos: "名詞", translation: "家庭作業" },
  test: { pos: "名詞", translation: "測驗" },
  quiz: { pos: "名詞", translation: "小測驗" },
  exam: { pos: "名詞", translation: "考試" },
  grade: { pos: "名詞", translation: "成績" },
  report: { pos: "名詞", translation: "報告" },
  project: { pos: "名詞", translation: "項目" },
  subject: { pos: "名詞", translation: "科目" },
  math: { pos: "名詞", translation: "數學" },
  science: { pos: "名詞", translation: "科學" },
  history: { pos: "名詞", translation: "歷史" },
  geography: { pos: "名詞", translation: "地理" },
  art: { pos: "名詞", translation: "藝術" },
  music: { pos: "名詞", translation: "音樂" },
  gym: { pos: "名詞", translation: "體育館" },
  library: { pos: "名詞", translation: "圖書館" },
  cafeteria: { pos: "名詞", translation: "自助餐廳" },
  office: { pos: "名詞", translation: "辦公室" },
  notebook: { pos: "名詞", translation: "筆記本" },
  textbook: { pos: "名詞", translation: "教科書" },
  dictionary: { pos: "名詞", translation: "字典" },
  eraser: { pos: "名詞", translation: "橡皮擦" },
  ruler: { pos: "名詞", translation: "尺" },
  marker: { pos: "名詞", translation: "記號筆" },
  chalk: { pos: "名詞", translation: "粉筆" },
  blackboard: { pos: "名詞", translation: "黑板" },
  whiteboard: { pos: "名詞", translation: "白板" },
  backpack: { pos: "名詞", translation: "背包" },
  lunchbox: { pos: "名詞", translation: "午餐盒" },

  // House & Home
  building: { pos: "名詞", translation: "建築物" },
  apartment: { pos: "名詞", translation: "公寓" },
  bedroom: { pos: "名詞", translation: "臥室" },
  bathroom: { pos: "名詞", translation: "浴室" },
  kitchen: { pos: "名詞", translation: "廚房" },
  dining: { pos: "名詞", translation: "餐廳" },
  living: { pos: "名詞", translation: "客廳" },
  garage: { pos: "名詞", translation: "車庫" },
  attic: { pos: "名詞", translation: "閣樓" },
  basement: { pos: "名詞", translation: "地下室" },
  hall: { pos: "名詞", translation: "走廊" },
  stairs: { pos: "名詞", translation: "樓梯" },
  step: { pos: "名詞", translation: "台階" },
  steps: { pos: "名詞", translation: "台階" },
  floor: { pos: "名詞", translation: "地板" },
  ceiling: { pos: "名詞", translation: "天花板" },
  wall: { pos: "名詞", translation: "牆" },
  roof: { pos: "名詞", translation: "屋頂" },
  chimney: { pos: "名詞", translation: "煙囪" },
  fence: { pos: "名詞", translation: "圍欄" },
  gate: { pos: "名詞", translation: "大門" },
  yard: { pos: "名詞", translation: "院子" },
  porch: { pos: "名詞", translation: "門廊" },
  balcony: { pos: "名詞", translation: "陽台" },
  furniture: { pos: "名詞", translation: "家具" },
  sofa: { pos: "名詞", translation: "沙發" },
  couch: { pos: "名詞", translation: "長沙發" },
  armchair: { pos: "名詞", translation: "扶手椅" },
  stool: { pos: "名詞", translation: "凳子" },
  bench: { pos: "名詞", translation: "長凳" },
  bed: { pos: "名詞", translation: "床" },
  bunk: { pos: "名詞", translation: "雙層床" },
  mattress: { pos: "名詞", translation: "床墊" },
  pillow: { pos: "名詞", translation: "枕頭" },
  blanket: { pos: "名詞", translation: "毯子" },
  sheet: { pos: "名詞", translation: "床單" },
  quilt: { pos: "名詞", translation: "被子" },
  curtain: { pos: "名詞", translation: "窗簾" },
  curtains: { pos: "名詞", translation: "窗簾" },
  blind: { pos: "名詞", translation: "百葉窗" },
  blinds: { pos: "名詞", translation: "百葉窗" },
  lamp: { pos: "名詞", translation: "燈" },
  bulb: { pos: "名詞", translation: "燈泡" },
  switch: { pos: "名詞", translation: "開關" },
  plug: { pos: "名詞", translation: "插頭" },
  socket: { pos: "名詞", translation: "插座" },
  mirror: { pos: "名詞", translation: "鏡子" },
  clock: { pos: "名詞", translation: "時鐘" },
  alarm: { pos: "名詞", translation: "鬧鐘" },
  calendar: { pos: "名詞", translation: "日曆" },
  shelf: { pos: "名詞", translation: "架子" },
  shelves: { pos: "名詞", translation: "架子" },
  drawer: { pos: "名詞", translation: "抽屜" },
  cabinet: { pos: "名詞", translation: "櫥櫃" },
  closet: { pos: "名詞", translation: "衣櫃" },
  wardrobe: { pos: "名詞", translation: "衣櫃" },
  hanger: { pos: "名詞", translation: "衣架" },
  basket: { pos: "名詞", translation: "籃子" },
  bin: { pos: "名詞", translation: "垃圾桶" },
  trash: { pos: "名詞", translation: "垃圾" },
  garbage: { pos: "名詞", translation: "垃圾" },
  broom: { pos: "名詞", translation: "掃帚" },
  dustpan: { pos: "名詞", translation: "畚箕" },
  vacuum: { pos: "名詞", translation: "吸塵器" },
  iron: { pos: "名詞", translation: "熨斗" },
  towel: { pos: "名詞", translation: "毛巾" },
  soap: { pos: "名詞", translation: "肥皂" },
  shampoo: { pos: "名詞", translation: "洗髮精" },
  toothbrush: { pos: "名詞", translation: "牙刷" },
  toothpaste: { pos: "名詞", translation: "牙膏" },
  comb: { pos: "名詞", translation: "梳子" },
  brush: { pos: "名詞", translation: "刷子" },
  tissue: { pos: "名詞", translation: "紙巾" },
  toilet: { pos: "名詞", translation: "廁所" },
  sink: { pos: "名詞", translation: "洗手槽" },
  bathtub: { pos: "名詞", translation: "浴缸" },
  shower: { pos: "名詞", translation: "淋浴" },
  faucet: { pos: "名詞", translation: "水龍頭" },
  tap: { pos: "名詞", translation: "水龍頭" },
  drain: { pos: "名詞", translation: "排水管" },
  stove: { pos: "名詞", translation: "爐子" },
  oven: { pos: "名詞", translation: "烤箱" },
  microwave: { pos: "名詞", translation: "微波爐" },
  refrigerator: { pos: "名詞", translation: "冰箱" },
  fridge: { pos: "名詞", translation: "冰箱" },
  freezer: { pos: "名詞", translation: "冷凍庫" },
  dishwasher: { pos: "名詞", translation: "洗碗機" },
  toaster: { pos: "名詞", translation: "烤麵包機" },
  blender: { pos: "名詞", translation: "攪拌機" },
  kettle: { pos: "名詞", translation: "水壺" },
  pot: { pos: "名詞", translation: "鍋" },
  pan: { pos: "名詞", translation: "平底鍋" },
  lid: { pos: "名詞", translation: "蓋子" },
  tray: { pos: "名詞", translation: "托盤" },
  napkin: { pos: "名詞", translation: "餐巾" },
  tablecloth: { pos: "名詞", translation: "桌布" },
  placemat: { pos: "名詞", translation: "餐墊" },
  chopstick: { pos: "名詞", translation: "筷子" },
  chopsticks: { pos: "名詞", translation: "筷子" },
  glass: { pos: "名詞", translation: "玻璃杯" },
  mug: { pos: "名詞", translation: "馬克杯" },
  pitcher: { pos: "名詞", translation: "水壺" },
  jar: { pos: "名詞", translation: "罐子" },
  can: { pos: "名詞", translation: "罐頭" },
  container: { pos: "名詞", translation: "容器" },

  // Transportation
  transportation: { pos: "名詞", translation: "交通工具" },
  vehicle: { pos: "名詞", translation: "車輛" },
  bus: { pos: "名詞", translation: "公車" },
  train: { pos: "名詞", translation: "火車" },
  subway: { pos: "名詞", translation: "地鐵" },
  airplane: { pos: "名詞", translation: "飛機" },
  plane: { pos: "名詞", translation: "飛機" },
  helicopter: { pos: "名詞", translation: "直升機" },
  rocket: { pos: "名詞", translation: "火箭" },
  spaceship: { pos: "名詞", translation: "太空船" },
  boat: { pos: "名詞", translation: "船" },
  ship: { pos: "名詞", translation: "船" },
  sailboat: { pos: "名詞", translation: "帆船" },
  yacht: { pos: "名詞", translation: "遊艇" },
  canoe: { pos: "名詞", translation: "獨木舟" },
  raft: { pos: "名詞", translation: "木筏" },
  truck: { pos: "名詞", translation: "卡車" },
  van: { pos: "名詞", translation: "廂型車" },
  taxi: { pos: "名詞", translation: "計程車" },
  ambulance: { pos: "名詞", translation: "救護車" },
  firetruck: { pos: "名詞", translation: "消防車" },
  motorcycle: { pos: "名詞", translation: "摩托車" },
  scooter: { pos: "名詞", translation: "滑板車" },
  skateboard: { pos: "名詞", translation: "滑板" },
  tricycle: { pos: "名詞", translation: "三輪車" },
  wagon: { pos: "名詞", translation: "推車" },
  cart: { pos: "名詞", translation: "手推車" },
  wheel: { pos: "名詞", translation: "輪子" },
  tire: { pos: "名詞", translation: "輪胎" },
  pedal: { pos: "名詞", translation: "踏板" },
  handlebar: { pos: "名詞", translation: "把手" },
  brake: { pos: "名詞", translation: "煞車" },
  engine: { pos: "名詞", translation: "引擎" },
  motor: { pos: "名詞", translation: "馬達" },
  horn: { pos: "名詞", translation: "喇叭" },
  siren: { pos: "名詞", translation: "警笛" },
  traffic: { pos: "名詞", translation: "交通" },
  road: { pos: "名詞", translation: "路" },
  street: { pos: "名詞", translation: "街道" },
  highway: { pos: "名詞", translation: "高速公路" },
  bridge: { pos: "名詞", translation: "橋" },
  tunnel: { pos: "名詞", translation: "隧道" },
  sidewalk: { pos: "名詞", translation: "人行道" },
  crosswalk: { pos: "名詞", translation: "斑馬線" },
  corner: { pos: "名詞", translation: "轉角" },
  intersection: { pos: "名詞", translation: "十字路口" },
  sign: { pos: "名詞", translation: "標誌" },
  signal: { pos: "名詞", translation: "信號" },
  parking: { pos: "名詞", translation: "停車" },

  // Places
  place: { pos: "名詞", translation: "地方" },
  store: { pos: "名詞", translation: "商店" },
  shop: { pos: "名詞", translation: "店鋪" },
  market: { pos: "名詞", translation: "市場" },
  supermarket: { pos: "名詞", translation: "超級市場" },
  mall: { pos: "名詞", translation: "購物中心" },
  restaurant: { pos: "名詞", translation: "餐廳" },
  cafe: { pos: "名詞", translation: "咖啡廳" },
  bakery: { pos: "名詞", translation: "麵包店" },
  hospital: { pos: "名詞", translation: "醫院" },
  clinic: { pos: "名詞", translation: "診所" },
  pharmacy: { pos: "名詞", translation: "藥局" },
  bank: { pos: "名詞", translation: "銀行" },
  post: { pos: "名詞", translation: "郵局" },
  station: { pos: "名詞", translation: "車站" },
  airport: { pos: "名詞", translation: "機場" },
  port: { pos: "名詞", translation: "港口" },
  hotel: { pos: "名詞", translation: "旅館" },
  motel: { pos: "名詞", translation: "汽車旅館" },
  museum: { pos: "名詞", translation: "博物館" },
  gallery: { pos: "名詞", translation: "美術館" },
  theater: { pos: "名詞", translation: "劇院" },
  cinema: { pos: "名詞", translation: "電影院" },
  stadium: { pos: "名詞", translation: "體育場" },
  arena: { pos: "名詞", translation: "競技場" },
  zoo: { pos: "名詞", translation: "動物園" },
  aquarium: { pos: "名詞", translation: "水族館" },
  farm: { pos: "名詞", translation: "農場" },
  barn: { pos: "名詞", translation: "穀倉" },
  field: { pos: "名詞", translation: "田野" },
  forest: { pos: "名詞", translation: "森林" },
  woods: { pos: "名詞", translation: "樹林" },
  jungle: { pos: "名詞", translation: "叢林" },
  desert: { pos: "名詞", translation: "沙漠" },
  cave: { pos: "名詞", translation: "洞穴" },
  hill: { pos: "名詞", translation: "小山" },
  valley: { pos: "名詞", translation: "山谷" },
  cliff: { pos: "名詞", translation: "懸崖" },
  river: { pos: "名詞", translation: "河流" },
  stream: { pos: "名詞", translation: "溪流" },
  creek: { pos: "名詞", translation: "小溪" },
  lake: { pos: "名詞", translation: "湖" },
  sea: { pos: "名詞", translation: "海" },
  shore: { pos: "名詞", translation: "岸" },
  coast: { pos: "名詞", translation: "海岸" },
  bay: { pos: "名詞", translation: "海灣" },
  island: { pos: "名詞", translation: "島嶼" },
  waterfall: { pos: "名詞", translation: "瀑布" },
  fountain: { pos: "名詞", translation: "噴泉" },
  swamp: { pos: "名詞", translation: "沼澤" },
  marsh: { pos: "名詞", translation: "濕地" },
  meadow: { pos: "名詞", translation: "草地" },
  path: { pos: "名詞", translation: "小徑" },
  trail: { pos: "名詞", translation: "小路" },
  alley: { pos: "名詞", translation: "小巷" },
  lane: { pos: "名詞", translation: "巷子" },
  avenue: { pos: "名詞", translation: "大道" },
  boulevard: { pos: "名詞", translation: "林蔭大道" },
  square: { pos: "名詞", translation: "廣場" },
  plaza: { pos: "名詞", translation: "廣場" },
  town: { pos: "名詞", translation: "城鎮" },
  city: { pos: "名詞", translation: "城市" },
  village: { pos: "名詞", translation: "村莊" },
  country: { pos: "名詞", translation: "國家" },
  nation: { pos: "名詞", translation: "國家" },
  world: { pos: "名詞", translation: "世界" },
  earth: { pos: "名詞", translation: "地球" },
  planet: { pos: "名詞", translation: "星球" },
  space: { pos: "名詞", translation: "太空" },
  universe: { pos: "名詞", translation: "宇宙" },

  // Additional Nature & Weather
  nature: { pos: "名詞", translation: "大自然" },
  rock: { pos: "名詞", translation: "岩石" },
  stone: { pos: "名詞", translation: "石頭" },
  pebble: { pos: "名詞", translation: "小石頭" },
  sand: { pos: "名詞", translation: "沙子" },
  dirt: { pos: "名詞", translation: "泥土" },
  mud: { pos: "名詞", translation: "泥巴" },
  clay: { pos: "名詞", translation: "黏土" },
  soil: { pos: "名詞", translation: "土壤" },
  seed: { pos: "名詞", translation: "種子" },
  root: { pos: "名詞", translation: "根" },
  stem: { pos: "名詞", translation: "莖" },
  branch: { pos: "名詞", translation: "樹枝" },
  twig: { pos: "名詞", translation: "細枝" },
  bark: { pos: "名詞", translation: "樹皮" },
  trunk: { pos: "名詞", translation: "樹幹" },
  bush: { pos: "名詞", translation: "灌木" },
  shrub: { pos: "名詞", translation: "灌木叢" },
  vine: { pos: "名詞", translation: "藤" },
  weed: { pos: "名詞", translation: "雜草" },
  moss: { pos: "名詞", translation: "苔蘚" },
  fern: { pos: "名詞", translation: "蕨類" },
  cactus: { pos: "名詞", translation: "仙人掌" },
  rose: { pos: "名詞", translation: "玫瑰" },
  tulip: { pos: "名詞", translation: "鬱金香" },
  daisy: { pos: "名詞", translation: "雛菊" },
  sunflower: { pos: "名詞", translation: "向日葵" },
  dandelion: { pos: "名詞", translation: "蒲公英" },
  blossom: { pos: "名詞", translation: "花朵" },
  petal: { pos: "名詞", translation: "花瓣" },
  bud: { pos: "名詞", translation: "花苞" },
  thorn: { pos: "名詞", translation: "刺" },
  berry: { pos: "名詞", translation: "莓果" },
  fruit: { pos: "名詞", translation: "水果" },
  crop: { pos: "名詞", translation: "農作物" },
  harvest: { pos: "名詞", translation: "收穫" },
  hay: { pos: "名詞", translation: "乾草" },
  straw: { pos: "名詞", translation: "稻草" },
  wheat: { pos: "名詞", translation: "小麥" },
  thunder: { pos: "名詞", translation: "雷" },
  lightning: { pos: "名詞", translation: "閃電" },
  storm: { pos: "名詞", translation: "暴風雨" },
  hurricane: { pos: "名詞", translation: "颶風" },
  tornado: { pos: "名詞", translation: "龍捲風" },
  blizzard: { pos: "名詞", translation: "暴風雪" },
  hail: { pos: "名詞", translation: "冰雹" },
  sleet: { pos: "名詞", translation: "雨夾雪" },
  fog: { pos: "名詞", translation: "霧" },
  mist: { pos: "名詞", translation: "薄霧" },
  dew: { pos: "名詞", translation: "露水" },
  frost: { pos: "名詞", translation: "霜" },
  ice: { pos: "名詞", translation: "冰" },
  icicle: { pos: "名詞", translation: "冰柱" },
  snowflake: { pos: "名詞", translation: "雪花" },
  snowman: { pos: "名詞", translation: "雪人" },
  puddle: { pos: "名詞", translation: "水坑" },
  drop: { pos: "名詞", translation: "水滴" },
  wave: { pos: "名詞", translation: "波浪" },
  tide: { pos: "名詞", translation: "潮汐" },
  current: { pos: "名詞", translation: "水流" },
  bubble: { pos: "名詞", translation: "泡泡" },
  splash: { pos: "名詞", translation: "濺水" },
  ripple: { pos: "名詞", translation: "漣漪" },
  shadow: { pos: "名詞", translation: "影子" },
  shade: { pos: "名詞", translation: "陰影" },
  beam: { pos: "名詞", translation: "光束" },
  ray: { pos: "名詞", translation: "光線" },
  glow: { pos: "名詞", translation: "光輝" },
  shine: { pos: "名詞", translation: "光澤" },
  sparkle: { pos: "名詞", translation: "閃光" },
  twinkle: { pos: "名詞", translation: "閃爍" },
  flash: { pos: "名詞", translation: "閃光" },
  dawn: { pos: "名詞", translation: "黎明" },
  sunrise: { pos: "名詞", translation: "日出" },
  sunset: { pos: "名詞", translation: "日落" },
  dusk: { pos: "名詞", translation: "黃昏" },
  twilight: { pos: "名詞", translation: "暮光" },
  midnight: { pos: "名詞", translation: "午夜" },
  noon: { pos: "名詞", translation: "正午" },

  // Musical Instruments & Music
  instrument: { pos: "名詞", translation: "樂器" },
  piano: { pos: "名詞", translation: "鋼琴" },
  guitar: { pos: "名詞", translation: "吉他" },
  violin: { pos: "名詞", translation: "小提琴" },
  drum: { pos: "名詞", translation: "鼓" },
  drums: { pos: "名詞", translation: "鼓" },
  flute: { pos: "名詞", translation: "長笛" },
  trumpet: { pos: "名詞", translation: "小號" },
  saxophone: { pos: "名詞", translation: "薩克斯風" },
  clarinet: { pos: "名詞", translation: "單簧管" },
  harmonica: { pos: "名詞", translation: "口琴" },
  recorder: { pos: "名詞", translation: "直笛" },
  xylophone: { pos: "名詞", translation: "木琴" },
  tambourine: { pos: "名詞", translation: "鈴鼓" },
  maracas: { pos: "名詞", translation: "沙鈴" },
  cymbals: { pos: "名詞", translation: "鈸" },
  bell: { pos: "名詞", translation: "鈴" },
  song: { pos: "名詞", translation: "歌曲" },
  melody: { pos: "名詞", translation: "旋律" },
  rhythm: { pos: "名詞", translation: "節奏" },
  beat: { pos: "名詞", translation: "節拍" },
  tune: { pos: "名詞", translation: "曲調" },
  note: { pos: "名詞", translation: "音符" },
  sound: { pos: "名詞", translation: "聲音" },
  noise: { pos: "名詞", translation: "噪音" },
  voice: { pos: "名詞", translation: "聲音" },
  chorus: { pos: "名詞", translation: "合唱" },
  band: { pos: "名詞", translation: "樂隊" },
  orchestra: { pos: "名詞", translation: "管弦樂團" },
  concert: { pos: "名詞", translation: "音樂會" },
  performance: { pos: "名詞", translation: "表演" },
  show: { pos: "名詞", translation: "演出" },

  // Sports & Activities
  sport: { pos: "名詞", translation: "運動" },
  game: { pos: "名詞", translation: "遊戲" },
  team: { pos: "名詞", translation: "團隊" },
  player: { pos: "名詞", translation: "選手" },
  coach: { pos: "名詞", translation: "教練" },
  baseball: { pos: "名詞", translation: "棒球" },
  basketball: { pos: "名詞", translation: "籃球" },
  football: { pos: "名詞", translation: "足球" },
  soccer: { pos: "名詞", translation: "足球" },
  volleyball: { pos: "名詞", translation: "排球" },
  tennis: { pos: "名詞", translation: "網球" },
  golf: { pos: "名詞", translation: "高爾夫" },
  hockey: { pos: "名詞", translation: "曲棍球" },
  skating: { pos: "名詞", translation: "溜冰" },
  skiing: { pos: "名詞", translation: "滑雪" },
  swimming: { pos: "名詞", translation: "游泳" },
  diving: { pos: "名詞", translation: "跳水" },
  surfing: { pos: "名詞", translation: "衝浪" },
  fishing: { pos: "名詞", translation: "釣魚" },
  hiking: { pos: "名詞", translation: "健行" },
  camping: { pos: "名詞", translation: "露營" },
  climbing: { pos: "名詞", translation: "攀爬" },
  jogging: { pos: "名詞", translation: "慢跑" },
  racing: { pos: "名詞", translation: "賽跑" },
  gymnastics: { pos: "名詞", translation: "體操" },
  wrestling: { pos: "名詞", translation: "摔角" },
  boxing: { pos: "名詞", translation: "拳擊" },
  martial: { pos: "形容詞", translation: "武術的" },
  karate: { pos: "名詞", translation: "空手道" },
  judo: { pos: "名詞", translation: "柔道" },
  yoga: { pos: "名詞", translation: "瑜珈" },
  exercise: { pos: "名詞", translation: "運動" },
  race: { pos: "名詞", translation: "比賽" },
  match: { pos: "名詞", translation: "比賽" },
  tournament: { pos: "名詞", translation: "錦標賽" },
  championship: { pos: "名詞", translation: "冠軍賽" },
  winner: { pos: "名詞", translation: "贏家" },
  loser: { pos: "名詞", translation: "輸家" },
  prize: { pos: "名詞", translation: "獎品" },
  trophy: { pos: "名詞", translation: "獎盃" },
  medal: { pos: "名詞", translation: "獎牌" },
  score: { pos: "名詞", translation: "得分" },
  point: { pos: "名詞", translation: "分數" },
  goal: { pos: "名詞", translation: "目標" },
  target: { pos: "名詞", translation: "目標" },
  aim: { pos: "名詞", translation: "目的" },

  // Toys & Games
  puzzle: { pos: "名詞", translation: "拼圖" },
  block: { pos: "名詞", translation: "積木" },
  blocks: { pos: "名詞", translation: "積木" },
  lego: { pos: "名詞", translation: "樂高" },
  robot: { pos: "名詞", translation: "機器人" },
  teddy: { pos: "名詞", translation: "泰迪熊" },
  stuffed: { pos: "形容詞", translation: "填充的" },
  action: { pos: "名詞", translation: "動作" },
  figure: { pos: "名詞", translation: "人偶" },
  board: { pos: "名詞", translation: "棋盤" },
  card: { pos: "名詞", translation: "卡片" },
  cards: { pos: "名詞", translation: "紙牌" },
  dice: { pos: "名詞", translation: "骰子" },
  marble: { pos: "名詞", translation: "彈珠" },
  marbles: { pos: "名詞", translation: "彈珠" },
  yo: { pos: "名詞", translation: "溜溜球" },
  frisbee: { pos: "名詞", translation: "飛盤" },
  hoop: { pos: "名詞", translation: "呼拉圈" },
  jump: { pos: "名詞", translation: "跳繩" },
  rope: { pos: "名詞", translation: "繩子" },
  swing: { pos: "名詞", translation: "鞦韆" },
  slide: { pos: "名詞", translation: "滑梯" },
  seesaw: { pos: "名詞", translation: "蹺蹺板" },
  sandbox: { pos: "名詞", translation: "沙箱" },
  trampoline: { pos: "名詞", translation: "彈跳床" },

  // Technology & Electronics
  computer: { pos: "名詞", translation: "電腦" },
  laptop: { pos: "名詞", translation: "筆記型電腦" },
  tablet: { pos: "名詞", translation: "平板電腦" },
  phone: { pos: "名詞", translation: "電話" },
  telephone: { pos: "名詞", translation: "電話" },
  smartphone: { pos: "名詞", translation: "智慧型手機" },
  camera: { pos: "名詞", translation: "相機" },
  video: { pos: "名詞", translation: "影片" },
  television: { pos: "名詞", translation: "電視" },
  tv: { pos: "名詞", translation: "電視" },
  radio: { pos: "名詞", translation: "收音機" },
  speaker: { pos: "名詞", translation: "喇叭" },
  headphone: { pos: "名詞", translation: "耳機" },
  headphones: { pos: "名詞", translation: "耳機" },
  earphone: { pos: "名詞", translation: "耳機" },
  earphones: { pos: "名詞", translation: "耳機" },
  screen: { pos: "名詞", translation: "螢幕" },
  monitor: { pos: "名詞", translation: "顯示器" },
  keyboard: { pos: "名詞", translation: "鍵盤" },
  mouse: { pos: "名詞", translation: "滑鼠" },
  printer: { pos: "名詞", translation: "印表機" },
  scanner: { pos: "名詞", translation: "掃描機" },
  remote: { pos: "名詞", translation: "遙控器" },
  battery: { pos: "名詞", translation: "電池" },
  charger: { pos: "名詞", translation: "充電器" },
  cable: { pos: "名詞", translation: "電纜" },
  wire: { pos: "名詞", translation: "電線" },
  internet: { pos: "名詞", translation: "網路" },
  wifi: { pos: "名詞", translation: "無線網路" },
  email: { pos: "名詞", translation: "電子郵件" },
  message: { pos: "名詞", translation: "訊息" },
  text: { pos: "名詞", translation: "文字" },
  app: { pos: "名詞", translation: "應用程式" },
  application: { pos: "名詞", translation: "應用程式" },
  program: { pos: "名詞", translation: "程式" },
  software: { pos: "名詞", translation: "軟體" },
  website: { pos: "名詞", translation: "網站" },
  page: { pos: "名詞", translation: "頁面" },
  link: { pos: "名詞", translation: "連結" },
  file: { pos: "名詞", translation: "檔案" },
  folder: { pos: "名詞", translation: "資料夾" },
  document: { pos: "名詞", translation: "文件" },
  data: { pos: "名詞", translation: "數據" },
  information: { pos: "名詞", translation: "資訊" },

  // Additional Adjectives - Appearance
  colorful: { pos: "形容詞", translation: "色彩繽紛的" },
  plain: { pos: "形容詞", translation: "樸素的" },
  fancy: { pos: "形容詞", translation: "花俏的" },
  simple: { pos: "形容詞", translation: "簡單的" },
  complex: { pos: "形容詞", translation: "複雜的" },
  straight: { pos: "形容詞", translation: "直的" },
  curved: { pos: "形容詞", translation: "彎曲的" },
  crooked: { pos: "形容詞", translation: "歪的" },
  bent: { pos: "形容詞", translation: "彎的" },
  flat: { pos: "形容詞", translation: "平的" },
  sharp: { pos: "形容詞", translation: "尖銳的" },
  dull: { pos: "形容詞", translation: "鈍的" },
  pointed: { pos: "形容詞", translation: "尖的" },
  blunt: { pos: "形容詞", translation: "鈍的" },
  broken: { pos: "形容詞", translation: "破的" },
  whole: { pos: "形容詞", translation: "完整的" },
  complete: { pos: "形容詞", translation: "完全的" },
  partial: { pos: "形容詞", translation: "部分的" },
  perfect: { pos: "形容詞", translation: "完美的" },
  terrible: { pos: "形容詞", translation: "糟糕的" },
  awful: { pos: "形容詞", translation: "可怕的" },
  wonderful: { pos: "形容詞", translation: "美妙的" },
  excellent: { pos: "形容詞", translation: "優秀的" },
  amazing: { pos: "形容詞", translation: "驚人的" },
  fantastic: { pos: "形容詞", translation: "極好的" },
  fabulous: { pos: "形容詞", translation: "絕佳的" },
  horrible: { pos: "形容詞", translation: "可怕的" },
  great: { pos: "形容詞", translation: "偉大的" },
  super: { pos: "形容詞", translation: "超級的" },
  special: { pos: "形容詞", translation: "特別的" },
  normal: { pos: "形容詞", translation: "正常的" },
  ordinary: { pos: "形容詞", translation: "普通的" },
  unusual: { pos: "形容詞", translation: "不尋常的" },
  strange: { pos: "形容詞", translation: "奇怪的" },
  weird: { pos: "形容詞", translation: "怪異的" },
  odd: { pos: "形容詞", translation: "奇怪的" },
  funny: { pos: "形容詞", translation: "有趣的" },
  silly: { pos: "形容詞", translation: "愚蠢的" },
  crazy: { pos: "形容詞", translation: "瘋狂的" },
  wild: { pos: "形容詞", translation: "野生的" },
  calm: { pos: "形容詞", translation: "平靜的" },
  peaceful: { pos: "形容詞", translation: "和平的" },
  gentle: { pos: "形容詞", translation: "溫和的" },
  rough: { pos: "形容詞", translation: "粗糙的" },
  tough: { pos: "形容詞", translation: "堅韌的" },
  tender: { pos: "形容詞", translation: "溫柔的" },
  fierce: { pos: "形容詞", translation: "兇猛的" },
  mild: { pos: "形容詞", translation: "溫和的" },
  strong: { pos: "形容詞", translation: "強壯的" },
  weak: { pos: "形容詞", translation: "虛弱的" },
  powerful: { pos: "形容詞", translation: "強大的" },
  fragile: { pos: "形容詞", translation: "脆弱的" },
  delicate: { pos: "形容詞", translation: "精緻的" },
  sturdy: { pos: "形容詞", translation: "堅固的" },
  solid: { pos: "形容詞", translation: "堅固的" },
  firm: { pos: "形容詞", translation: "堅定的" },
  loose: { pos: "形容詞", translation: "鬆的" },
  tight: { pos: "形容詞", translation: "緊的" },
  stiff: { pos: "形容詞", translation: "僵硬的" },
  flexible: { pos: "形容詞", translation: "靈活的" },
  elastic: { pos: "形容詞", translation: "有彈性的" },
  stretchy: { pos: "形容詞", translation: "有彈性的" },
  sticky: { pos: "形容詞", translation: "黏的" },
  slippery: { pos: "形容詞", translation: "滑的" },
  greasy: { pos: "形容詞", translation: "油膩的" },
  oily: { pos: "形容詞", translation: "油的" },
  watery: { pos: "形容詞", translation: "水的" },
  juicy: { pos: "形容詞", translation: "多汁的" },
  creamy: { pos: "形容詞", translation: "奶油狀的" },
  crunchy: { pos: "形容詞", translation: "脆的" },
  crispy: { pos: "形容詞", translation: "酥脆的" },
  chewy: { pos: "形容詞", translation: "有嚼勁的" },
  tender: { pos: "形容詞", translation: "嫩的" },

  // Additional Adjectives - Taste and Smell
  delicious: { pos: "形容詞", translation: "美味的" },
  yummy: { pos: "形容詞", translation: "好吃的" },
  tasty: { pos: "形容詞", translation: "美味的" },
  bland: { pos: "形容詞", translation: "淡而無味的" },
  flavorful: { pos: "形容詞", translation: "有味道的" },
  sweet: { pos: "形容詞", translation: "甜的" },
  sour: { pos: "形容詞", translation: "酸的" },
  bitter: { pos: "形容詞", translation: "苦的" },
  salty: { pos: "形容詞", translation: "鹹的" },
  spicy: { pos: "形容詞", translation: "辣的" },
  mild: { pos: "形容詞", translation: "溫和的" },
  fresh: { pos: "形容詞", translation: "新鮮的" },
  stale: { pos: "形容詞", translation: "不新鮮的" },
  rotten: { pos: "形容詞", translation: "腐爛的" },
  ripe: { pos: "形容詞", translation: "成熟的" },
  unripe: { pos: "形容詞", translation: "未成熟的" },
  raw: { pos: "形容詞", translation: "生的" },
  cooked: { pos: "形容詞", translation: "熟的" },
  burnt: { pos: "形容詞", translation: "燒焦的" },
  smelly: { pos: "形容詞", translation: "有臭味的" },
  fragrant: { pos: "形容詞", translation: "芳香的" },
  stinky: { pos: "形容詞", translation: "臭的" },

  // Additional Adjectives - Feelings
  comfortable: { pos: "形容詞", translation: "舒適的" },
  uncomfortable: { pos: "形容詞", translation: "不舒服的" },
  cozy: { pos: "形容詞", translation: "溫馨的" },
  relaxed: { pos: "形容詞", translation: "放鬆的" },
  tense: { pos: "形容詞", translation: "緊張的" },
  bored: { pos: "形容詞", translation: "無聊的" },
  interested: { pos: "形容詞", translation: "感興趣的" },
  curious: { pos: "形容詞", translation: "好奇的" },
  confused: { pos: "形容詞", translation: "困惑的" },
  surprised: { pos: "形容詞", translation: "驚訝的" },
  shocked: { pos: "形容詞", translation: "震驚的" },
  amazed: { pos: "形容詞", translation: "驚奇的" },
  disappointed: { pos: "形容詞", translation: "失望的" },
  frustrated: { pos: "形容詞", translation: "沮喪的" },
  annoyed: { pos: "形容詞", translation: "惱怒的" },
  upset: { pos: "形容詞", translation: "心煩的" },
  lonely: { pos: "形容詞", translation: "孤獨的" },
  jealous: { pos: "形容詞", translation: "嫉妒的" },
  grateful: { pos: "形容詞", translation: "感激的" },
  thankful: { pos: "形容詞", translation: "感謝的" },
  hopeful: { pos: "形容詞", translation: "有希望的" },
  hopeless: { pos: "形容詞", translation: "絕望的" },
  cheerful: { pos: "形容詞", translation: "開朗的" },
  grumpy: { pos: "形容詞", translation: "脾氣暴躁的" },
  moody: { pos: "形容詞", translation: "情緒化的" },
  cranky: { pos: "形容詞", translation: "暴躁的" },

  // Additional Adjectives - Personality
  friendly: { pos: "形容詞", translation: "友善的" },
  unfriendly: { pos: "形容詞", translation: "不友善的" },
  helpful: { pos: "形容詞", translation: "有幫助的" },
  helpful: { pos: "形容詞", translation: "樂於助人的" },
  selfish: { pos: "形容詞", translation: "自私的" },
  generous: { pos: "形容詞", translation: "慷慨的" },
  greedy: { pos: "形容詞", translation: "貪婪的" },
  honest: { pos: "形容詞", translation: "誠實的" },
  dishonest: { pos: "形容詞", translation: "不誠實的" },
  truthful: { pos: "形容詞", translation: "真實的" },
  loyal: { pos: "形容詞", translation: "忠誠的" },
  faithful: { pos: "形容詞", translation: "忠實的" },
  patient: { pos: "形容詞", translation: "有耐心的" },
  impatient: { pos: "形容詞", translation: "沒耐心的" },
  careful: { pos: "形容詞", translation: "小心的" },
  careless: { pos: "形容詞", translation: "粗心的" },
  clever: { pos: "形容詞", translation: "聰明的" },
  smart: { pos: "形容詞", translation: "聰明的" },
  wise: { pos: "形容詞", translation: "明智的" },
  foolish: { pos: "形容詞", translation: "愚蠢的" },
  stupid: { pos: "形容詞", translation: "愚蠢的" },
  intelligent: { pos: "形容詞", translation: "聰明的" },
  bright: { pos: "形容詞", translation: "聰穎的" },
  dumb: { pos: "形容詞", translation: "愚笨的" },
  lazy: { pos: "形容詞", translation: "懶惰的" },
  hardworking: { pos: "形容詞", translation: "勤奮的" },
  diligent: { pos: "形容詞", translation: "勤勉的" },
  active: { pos: "形容詞", translation: "活躍的" },
  energetic: { pos: "形容詞", translation: "精力充沛的" },
  playful: { pos: "形容詞", translation: "愛玩的" },
  serious: { pos: "形容詞", translation: "認真的" },
  funny: { pos: "形容詞", translation: "滑稽的" },
  creative: { pos: "形容詞", translation: "有創造力的" },
  imaginative: { pos: "形容詞", translation: "有想像力的" },
  artistic: { pos: "形容詞", translation: "有藝術才華的" },
  musical: { pos: "形容詞", translation: "有音樂天賦的" },
  athletic: { pos: "形容詞", translation: "運動的" },
  competitive: { pos: "形容詞", translation: "好勝的" },
  cooperative: { pos: "形容詞", translation: "合作的" },

  // More Common Words
  thing: { pos: "名詞", translation: "東西" },
  stuff: { pos: "名詞", translation: "東西" },
  object: { pos: "名詞", translation: "物體" },
  item: { pos: "名詞", translation: "物品" },
  piece: { pos: "名詞", translation: "一塊" },
  part: { pos: "名詞", translation: "部分" },
  half: { pos: "名詞", translation: "一半" },
  quarter: { pos: "名詞", translation: "四分之一" },
  whole: { pos: "名詞", translation: "整體" },
  set: { pos: "名詞", translation: "一套" },
  group: { pos: "名詞", translation: "團體" },
  bunch: { pos: "名詞", translation: "一束" },
  pile: { pos: "名詞", translation: "一堆" },
  stack: { pos: "名詞", translation: "一疊" },
  row: { pos: "名詞", translation: "一排" },
  column: { pos: "名詞", translation: "一列" },
  pair: { pos: "名詞", translation: "一對" },
  couple: { pos: "名詞", translation: "一對" },
  few: { pos: "名詞", translation: "少數" },
  several: { pos: "形容詞", translation: "幾個" },
  lot: { pos: "名詞", translation: "許多" },
  lots: { pos: "名詞", translation: "許多" },
  plenty: { pos: "名詞", translation: "大量" },
  amount: { pos: "名詞", translation: "數量" },
  number: { pos: "名詞", translation: "數字" },
  total: { pos: "名詞", translation: "總數" },
  sum: { pos: "名詞", translation: "總和" },
  difference: { pos: "名詞", translation: "差別" },
  same: { pos: "形容詞", translation: "相同的" },
  different: { pos: "形容詞", translation: "不同的" },
  similar: { pos: "形容詞", translation: "相似的" },
  alike: { pos: "形容詞", translation: "相像的" },
  equal: { pos: "形容詞", translation: "相等的" },
  unequal: { pos: "形容詞", translation: "不相等的" },
  more: { pos: "形容詞", translation: "更多的" },
  less: { pos: "形容詞", translation: "更少的" },
  most: { pos: "形容詞", translation: "最多的" },
  least: { pos: "形容詞", translation: "最少的" },
  best: { pos: "形容詞", translation: "最好的" },
  worst: { pos: "形容詞", translation: "最差的" },
  better: { pos: "形容詞", translation: "更好的" },
  worse: { pos: "形容詞", translation: "更差的" },
  main: { pos: "形容詞", translation: "主要的" },
  primary: { pos: "形容詞", translation: "首要的" },
  important: { pos: "形容詞", translation: "重要的" },
  unimportant: { pos: "形容詞", translation: "不重要的" },
  necessary: { pos: "形容詞", translation: "必要的" },
  unnecessary: { pos: "形容詞", translation: "不必要的" },
  useful: { pos: "形容詞", translation: "有用的" },
  useless: { pos: "形容詞", translation: "無用的" },
  helpful: { pos: "形容詞", translation: "有幫助的" },
  harmful: { pos: "形容詞", translation: "有害的" },
  safe: { pos: "形容詞", translation: "安全的" },
  dangerous: { pos: "形容詞", translation: "危險的" },
  risky: { pos: "形容詞", translation: "冒險的" },
  careful: { pos: "形容詞", translation: "謹慎的" },
  real: { pos: "形容詞", translation: "真實的" },
  fake: { pos: "形容詞", translation: "假的" },
  true: { pos: "形容詞", translation: "真的" },
  false: { pos: "形容詞", translation: "假的" },
  correct: { pos: "形容詞", translation: "正確的" },
  incorrect: { pos: "形容詞", translation: "不正確的" },
  right: { pos: "形容詞", translation: "正確的" },
  wrong: { pos: "形容詞", translation: "錯誤的" },
  sure: { pos: "形容詞", translation: "確定的" },
  certain: { pos: "形容詞", translation: "確定的" },
  unsure: { pos: "形容詞", translation: "不確定的" },
  uncertain: { pos: "形容詞", translation: "不確定的" },
  possible: { pos: "形容詞", translation: "可能的" },
  impossible: { pos: "形容詞", translation: "不可能的" },
  probable: { pos: "形容詞", translation: "很可能的" },
  likely: { pos: "形容詞", translation: "可能的" },
  unlikely: { pos: "形容詞", translation: "不太可能的" },
  maybe: { pos: "副詞", translation: "也許" },
  perhaps: { pos: "副詞", translation: "也許" },
  probably: { pos: "副詞", translation: "可能" },
  definitely: { pos: "副詞", translation: "絕對" },
  certainly: { pos: "副詞", translation: "當然" },
  surely: { pos: "副詞", translation: "肯定" },
  absolutely: { pos: "副詞", translation: "絕對地" },
  completely: { pos: "副詞", translation: "完全地" },
  totally: { pos: "副詞", translation: "完全地" },
  partly: { pos: "副詞", translation: "部分地" },
  mostly: { pos: "副詞", translation: "大多" },
  mainly: { pos: "副詞", translation: "主要地" },
  especially: { pos: "副詞", translation: "尤其" },
  particularly: { pos: "副詞", translation: "特別" },
  exactly: { pos: "副詞", translation: "確切地" },
  nearly: { pos: "副詞", translation: "幾乎" },
  barely: { pos: "副詞", translation: "勉強" },
  hardly: { pos: "副詞", translation: "幾乎不" },
  scarcely: { pos: "副詞", translation: "幾乎不" },
  quite: { pos: "副詞", translation: "相當" },
  rather: { pos: "副詞", translation: "相當" },
  pretty: { pos: "副詞", translation: "頗" },
  fairly: { pos: "副詞", translation: "相當" },
  extremely: { pos: "副詞", translation: "極其" },
  incredibly: { pos: "副詞", translation: "難以置信地" },
  terribly: { pos: "副詞", translation: "非常" },
  awfully: { pos: "副詞", translation: "非常" },
  badly: { pos: "副詞", translation: "嚴重地" },
  well: { pos: "副詞", translation: "好" },
  badly: { pos: "副詞", translation: "壞" },
  carefully: { pos: "副詞", translation: "仔細地" },
  quickly: { pos: "副詞", translation: "快速地" },
  slowly: { pos: "副詞", translation: "慢慢地" },
  loudly: { pos: "副詞", translation: "大聲地" },
  quietly: { pos: "副詞", translation: "安靜地" },
  gently: { pos: "副詞", translation: "溫柔地" },
  roughly: { pos: "副詞", translation: "粗暴地" },
  smoothly: { pos: "副詞", translation: "順利地" },
  easily: { pos: "副詞", translation: "容易地" },
  hard: { pos: "副詞", translation: "努力地" },
  softly: { pos: "副詞", translation: "輕輕地" },
  tightly: { pos: "副詞", translation: "緊緊地" },
  loosely: { pos: "副詞", translation: "鬆鬆地" },
  closely: { pos: "副詞", translation: "接近地" },
  widely: { pos: "副詞", translation: "廣泛地" },
  deeply: { pos: "副詞", translation: "深深地" },
  highly: { pos: "副詞", translation: "高度地" },
  low: { pos: "副詞", translation: "低" },
  early: { pos: "副詞", translation: "早" },
  late: { pos: "副詞", translation: "晚" },
  soon: { pos: "副詞", translation: "很快" },
  immediately: { pos: "副詞", translation: "立即" },
  instantly: { pos: "副詞", translation: "立刻" },
  suddenly: { pos: "副詞", translation: "突然" },
  gradually: { pos: "副詞", translation: "逐漸地" },
  eventually: { pos: "副詞", translation: "最終" },
  finally: { pos: "副詞", translation: "最後" },
  lately: { pos: "副詞", translation: "最近" },
  recently: { pos: "副詞", translation: "最近" },
  already: { pos: "副詞", translation: "已經" },
  yet: { pos: "副詞", translation: "還" },
  still: { pos: "副詞", translation: "仍然" },
  anymore: { pos: "副詞", translation: "不再" },
  forward: { pos: "副詞", translation: "向前" },
  backward: { pos: "副詞", translation: "向後" },
  sideways: { pos: "副詞", translation: "向側面" },
  upward: { pos: "副詞", translation: "向上" },
  downward: { pos: "副詞", translation: "向下" },
  inward: { pos: "副詞", translation: "向內" },
  outward: { pos: "副詞", translation: "向外" },
  away: { pos: "副詞", translation: "離開" },
  back: { pos: "副詞", translation: "回來" },
  home: { pos: "副詞", translation: "回家" },
  abroad: { pos: "副詞", translation: "在國外" },
  everywhere: { pos: "副詞", translation: "到處" },
  somewhere: { pos: "副詞", translation: "某處" },
  anywhere: { pos: "副詞", translation: "任何地方" },
  nowhere: { pos: "副詞", translation: "無處" },
  inside: { pos: "副詞", translation: "在裡面" },
  outside: { pos: "副詞", translation: "在外面" },
  upstairs: { pos: "副詞", translation: "在樓上" },
  downstairs: { pos: "副詞", translation: "在樓下" },
  overhead: { pos: "副詞", translation: "在頭頂上" },
  underground: { pos: "副詞", translation: "在地下" },
  nearby: { pos: "副詞", translation: "在附近" },
  faraway: { pos: "形容詞", translation: "遙遠的" },

  // Days of the Week
  monday: { pos: "名詞", translation: "星期一" },
  tuesday: { pos: "名詞", translation: "星期二" },
  wednesday: { pos: "名詞", translation: "星期三" },
  thursday: { pos: "名詞", translation: "星期四" },
  friday: { pos: "名詞", translation: "星期五" },
  saturday: { pos: "名詞", translation: "星期六" },
  sunday: { pos: "名詞", translation: "星期日" },
  weekday: { pos: "名詞", translation: "工作日" },

  // Months
  january: { pos: "名詞", translation: "一月" },
  february: { pos: "名詞", translation: "二月" },
  march: { pos: "名詞", translation: "三月" },
  april: { pos: "名詞", translation: "四月" },
  may: { pos: "名詞", translation: "五月" },
  june: { pos: "名詞", translation: "六月" },
  july: { pos: "名詞", translation: "七月" },
  august: { pos: "名詞", translation: "八月" },
  september: { pos: "名詞", translation: "九月" },
  october: { pos: "名詞", translation: "十月" },
  november: { pos: "名詞", translation: "十一月" },
  december: { pos: "名詞", translation: "十二月" },

  // Ordinal Numbers
  fourth: { pos: "數詞", translation: "第四" },
  fifth: { pos: "數詞", translation: "第五" },
  sixth: { pos: "數詞", translation: "第六" },
  seventh: { pos: "數詞", translation: "第七" },
  eighth: { pos: "數詞", translation: "第八" },
  ninth: { pos: "數詞", translation: "第九" },
  tenth: { pos: "數詞", translation: "第十" },
  eleventh: { pos: "數詞", translation: "第十一" },
  twelfth: { pos: "數詞", translation: "第十二" },
  twentieth: { pos: "數詞", translation: "第二十" },
  thirtieth: { pos: "數詞", translation: "第三十" },

  // Holidays and Celebrations
  holiday: { pos: "名詞", translation: "假日" },
  birthday: { pos: "名詞", translation: "生日" },
  party: { pos: "名詞", translation: "派對" },
  celebration: { pos: "名詞", translation: "慶祝" },
  festival: { pos: "名詞", translation: "節日" },
  christmas: { pos: "名詞", translation: "聖誕節" },
  halloween: { pos: "名詞", translation: "萬聖節" },
  easter: { pos: "名詞", translation: "復活節" },
  thanksgiving: { pos: "名詞", translation: "感恩節" },
  valentine: { pos: "名詞", translation: "情人節" },
  gift: { pos: "名詞", translation: "禮物" },
  present: { pos: "名詞", translation: "禮物" },
  card: { pos: "名詞", translation: "卡片" },
  decoration: { pos: "名詞", translation: "裝飾" },
  candle: { pos: "名詞", translation: "蠟燭" },
  firework: { pos: "名詞", translation: "煙火" },
  fireworks: { pos: "名詞", translation: "煙火" },
  costume: { pos: "名詞", translation: "服裝" },
  mask: { pos: "名詞", translation: "面具" },
  pumpkin: { pos: "名詞", translation: "南瓜" },
  turkey: { pos: "名詞", translation: "火雞" },
  santa: { pos: "名詞", translation: "聖誕老人" },
  reindeer: { pos: "名詞", translation: "馴鹿" },
  sleigh: { pos: "名詞", translation: "雪橇" },
  elf: { pos: "名詞", translation: "精靈" },
  angel: { pos: "名詞", translation: "天使" },
  wreath: { pos: "名詞", translation: "花圈" },
  ornament: { pos: "名詞", translation: "裝飾品" },
  stocking: { pos: "名詞", translation: "長襪" },

  // More Action Verbs for Kids
  celebrate: { pos: "動詞", translation: "慶祝" },
  decorate: { pos: "動詞", translation: "裝飾" },
  invite: { pos: "動詞", translation: "邀請" },
  join: { pos: "動詞", translation: "加入" },
  participate: { pos: "動詞", translation: "參加" },
  belong: { pos: "動詞", translation: "屬於" },
  own: { pos: "動詞", translation: "擁有" },
  borrow: { pos: "動詞", translation: "借" },
  lend: { pos: "動詞", translation: "借出" },
  rent: { pos: "動詞", translation: "租" },
  buy: { pos: "動詞", translation: "買" },
  sell: { pos: "動詞", translation: "賣" },
  pay: { pos: "動詞", translation: "付錢" },
  cost: { pos: "動詞", translation: "花費" },
  spend: { pos: "動詞", translation: "花費" },
  save: { pos: "動詞", translation: "節省" },
  earn: { pos: "動詞", translation: "賺取" },
  win: { pos: "動詞", translation: "贏" },
  lose: { pos: "動詞", translation: "輸" },
  tie: { pos: "動詞", translation: "平手" },
  fail: { pos: "動詞", translation: "失敗" },
  succeed: { pos: "動詞", translation: "成功" },
  improve: { pos: "動詞", translation: "改進" },
  worsen: { pos: "動詞", translation: "惡化" },
  increase: { pos: "動詞", translation: "增加" },
  decrease: { pos: "動詞", translation: "減少" },
  expand: { pos: "動詞", translation: "擴大" },
  reduce: { pos: "動詞", translation: "減少" },
  enlarge: { pos: "動詞", translation: "放大" },
  minimize: { pos: "動詞", translation: "最小化" },
  maximize: { pos: "動詞", translation: "最大化" },
  multiply: { pos: "動詞", translation: "乘" },
  copy: { pos: "動詞", translation: "複製" },
  imitate: { pos: "動詞", translation: "模仿" },
  mimic: { pos: "動詞", translation: "模仿" },
  follow: { pos: "動詞", translation: "跟隨" },
  lead: { pos: "動詞", translation: "帶領" },
  guide: { pos: "動詞", translation: "引導" },
  direct: { pos: "動詞", translation: "指導" },
  instruct: { pos: "動詞", translation: "指示" },
  explain: { pos: "動詞", translation: "解釋" },
  describe: { pos: "動詞", translation: "描述" },
  demonstrate: { pos: "動詞", translation: "示範" },
  illustrate: { pos: "動詞", translation: "說明" },
  prove: { pos: "動詞", translation: "證明" },
  test: { pos: "動詞", translation: "測試" },
  check: { pos: "動詞", translation: "檢查" },
  examine: { pos: "動詞", translation: "檢查" },
  inspect: { pos: "動詞", translation: "檢驗" },
  observe: { pos: "動詞", translation: "觀察" },
  notice: { pos: "動詞", translation: "注意到" },
  recognize: { pos: "動詞", translation: "認出" },
  identify: { pos: "動詞", translation: "識別" },
  distinguish: { pos: "動詞", translation: "區分" },
  separate: { pos: "動詞", translation: "分開" },
  combine: { pos: "動詞", translation: "結合" },
  join: { pos: "動詞", translation: "連接" },
  connect: { pos: "動詞", translation: "連接" },
  attach: { pos: "動詞", translation: "附加" },
  detach: { pos: "動詞", translation: "分離" },
  fasten: { pos: "動詞", translation: "繫緊" },
  loosen: { pos: "動詞", translation: "鬆開" },
  tighten: { pos: "動詞", translation: "拴緊" },
  secure: { pos: "動詞", translation: "固定" },
  release: { pos: "動詞", translation: "釋放" },
  free: { pos: "動詞", translation: "釋放" },
  trap: { pos: "動詞", translation: "困住" },
  capture: { pos: "動詞", translation: "捕獲" },
  escape: { pos: "動詞", translation: "逃脫" },
  flee: { pos: "動詞", translation: "逃跑" },
  chase: { pos: "動詞", translation: "追逐" },
  follow: { pos: "動詞", translation: "跟隨" },
  track: { pos: "動詞", translation: "追蹤" },
  hunt: { pos: "動詞", translation: "打獵" },
  gather: { pos: "動詞", translation: "收集" },
  pick: { pos: "動詞", translation: "採摘" },
  choose: { pos: "動詞", translation: "選擇" },
  select: { pos: "動詞", translation: "選擇" },
  decide: { pos: "動詞", translation: "決定" },
  determine: { pos: "動詞", translation: "決定" },
  conclude: { pos: "動詞", translation: "得出結論" },
  solve: { pos: "動詞", translation: "解決" },
  fix: { pos: "動詞", translation: "修理" },
  repair: { pos: "動詞", translation: "修理" },
  mend: { pos: "動詞", translation: "修補" },
  break: { pos: "動詞", translation: "打破" },
  crack: { pos: "動詞", translation: "破裂" },
  split: { pos: "動詞", translation: "分裂" },
  tear: { pos: "動詞", translation: "撕裂" },
  rip: { pos: "動詞", translation: "撕" },
  shred: { pos: "動詞", translation: "撕碎" },
  smash: { pos: "動詞", translation: "粉碎" },
  crush: { pos: "動詞", translation: "壓碎" },
  squash: { pos: "動詞", translation: "壓扁" },
  flatten: { pos: "動詞", translation: "壓平" },
  press: { pos: "動詞", translation: "壓" },
  push: { pos: "動詞", translation: "推" },
  shove: { pos: "動詞", translation: "推擠" },
  pull: { pos: "動詞", translation: "拉" },
  tug: { pos: "動詞", translation: "用力拉" },
  drag: { pos: "動詞", translation: "拖" },
  haul: { pos: "動詞", translation: "拖運" },
  transport: { pos: "動詞", translation: "運輸" },
  deliver: { pos: "動詞", translation: "遞送" },
  send: { pos: "動詞", translation: "發送" },
  receive: { pos: "動詞", translation: "收到" },
  accept: { pos: "動詞", translation: "接受" },
  reject: { pos: "動詞", translation: "拒絕" },
  refuse: { pos: "動詞", translation: "拒絕" },
  deny: { pos: "動詞", translation: "否認" },
  admit: { pos: "動詞", translation: "承認" },
  confess: { pos: "動詞", translation: "坦白" },
  agree: { pos: "動詞", translation: "同意" },
  disagree: { pos: "動詞", translation: "不同意" },
  argue: { pos: "動詞", translation: "爭論" },
  fight: { pos: "動詞", translation: "打架" },
  quarrel: { pos: "動詞", translation: "爭吵" },
  compete: { pos: "動詞", translation: "競爭" },
  cooperate: { pos: "動詞", translation: "合作" },
  collaborate: { pos: "動詞", translation: "協作" },
  assist: { pos: "動詞", translation: "協助" },
  support: { pos: "動詞", translation: "支持" },
  encourage: { pos: "動詞", translation: "鼓勵" },
  discourage: { pos: "動詞", translation: "阻止" },
  motivate: { pos: "動詞", translation: "激勵" },
  inspire: { pos: "動詞", translation: "啟發" },
  influence: { pos: "動詞", translation: "影響" },
  affect: { pos: "動詞", translation: "影響" },
  impact: { pos: "動詞", translation: "衝擊" },
  disturb: { pos: "動詞", translation: "打擾" },
  interrupt: { pos: "動詞", translation: "打斷" },
  bother: { pos: "動詞", translation: "打擾" },
  annoy: { pos: "動詞", translation: "煩擾" },
  irritate: { pos: "動詞", translation: "激怒" },
  frustrate: { pos: "動詞", translation: "使沮喪" },
  disappoint: { pos: "動詞", translation: "使失望" },
  satisfy: { pos: "動詞", translation: "使滿意" },
  please: { pos: "動詞", translation: "使高興" },
  delight: { pos: "動詞", translation: "使愉快" },
  enjoy: { pos: "動詞", translation: "享受" },
  appreciate: { pos: "動詞", translation: "欣賞" },
  admire: { pos: "動詞", translation: "欽佩" },
  respect: { pos: "動詞", translation: "尊重" },
  honor: { pos: "動詞", translation: "榮譽" },
  worship: { pos: "動詞", translation: "崇拜" },
  praise: { pos: "動詞", translation: "讚美" },
  compliment: { pos: "動詞", translation: "稱讚" },
  criticize: { pos: "動詞", translation: "批評" },
  blame: { pos: "動詞", translation: "責備" },
  scold: { pos: "動詞", translation: "責罵" },
  punish: { pos: "動詞", translation: "懲罰" },
  reward: { pos: "動詞", translation: "獎勵" },
  forgive: { pos: "動詞", translation: "原諒" },
  pardon: { pos: "動詞", translation: "寬恕" },
  apologize: { pos: "動詞", translation: "道歉" },
  regret: { pos: "動詞", translation: "後悔" },
  worry: { pos: "動詞", translation: "擔心" },
  fear: { pos: "動詞", translation: "害怕" },
  doubt: { pos: "動詞", translation: "懷疑" },
  trust: { pos: "動詞", translation: "信任" },
  believe: { pos: "動詞", translation: "相信" },
  hope: { pos: "動詞", translation: "希望" },
  wish: { pos: "動詞", translation: "希望" },
  expect: { pos: "動詞", translation: "期待" },
  anticipate: { pos: "動詞", translation: "預期" },
  predict: { pos: "動詞", translation: "預測" },
  guess: { pos: "動詞", translation: "猜" },
  imagine: { pos: "動詞", translation: "想像" },
  dream: { pos: "動詞", translation: "夢想" },
  pretend: { pos: "動詞", translation: "假裝" },
  act: { pos: "動詞", translation: "表演" },
  perform: { pos: "動詞", translation: "表演" },
  behave: { pos: "動詞", translation: "表現" },
  react: { pos: "動詞", translation: "反應" },
  respond: { pos: "動詞", translation: "回應" },
  reply: { pos: "動詞", translation: "回覆" },

  // More Nouns - Money and Shopping
  money: { pos: "名詞", translation: "錢" },
  cash: { pos: "名詞", translation: "現金" },
  coin: { pos: "名詞", translation: "硬幣" },
  dollar: { pos: "名詞", translation: "美元" },
  cent: { pos: "名詞", translation: "分" },
  penny: { pos: "名詞", translation: "便士" },
  nickel: { pos: "名詞", translation: "五分錢" },
  dime: { pos: "名詞", translation: "一角錢" },
  quarter: { pos: "名詞", translation: "二十五分錢" },
  bill: { pos: "名詞", translation: "紙幣" },
  change: { pos: "名詞", translation: "零錢" },
  price: { pos: "名詞", translation: "價格" },
  sale: { pos: "名詞", translation: "銷售" },
  discount: { pos: "名詞", translation: "折扣" },
  bargain: { pos: "名詞", translation: "便宜貨" },
  deal: { pos: "名詞", translation: "交易" },
  purchase: { pos: "名詞", translation: "購買" },
  receipt: { pos: "名詞", translation: "收據" },
  refund: { pos: "名詞", translation: "退款" },
  exchange: { pos: "名詞", translation: "交換" },
  customer: { pos: "名詞", translation: "顧客" },
  cashier: { pos: "名詞", translation: "收銀員" },
  clerk: { pos: "名詞", translation: "店員" },
  manager: { pos: "名詞", translation: "經理" },
  owner: { pos: "名詞", translation: "老闆" },
  seller: { pos: "名詞", translation: "賣家" },
  buyer: { pos: "名詞", translation: "買家" },
  shopper: { pos: "名詞", translation: "購物者" },

  // More Nouns - Health
  health: { pos: "名詞", translation: "健康" },
  medicine: { pos: "名詞", translation: "藥" },
  pill: { pos: "名詞", translation: "藥丸" },
  tablet: { pos: "名詞", translation: "藥片" },
  capsule: { pos: "名詞", translation: "膠囊" },
  syrup: { pos: "名詞", translation: "糖漿" },
  vitamin: { pos: "名詞", translation: "維生素" },
  bandage: { pos: "名詞", translation: "繃帶" },
  plaster: { pos: "名詞", translation: "膏藥" },
  bandaid: { pos: "名詞", translation: "OK繃" },
  ointment: { pos: "名詞", translation: "藥膏" },
  cream: { pos: "名詞", translation: "乳霜" },
  injection: { pos: "名詞", translation: "注射" },
  shot: { pos: "名詞", translation: "打針" },
  vaccine: { pos: "名詞", translation: "疫苗" },
  checkup: { pos: "名詞", translation: "健康檢查" },
  appointment: { pos: "名詞", translation: "預約" },
  patient: { pos: "名詞", translation: "病人" },
  illness: { pos: "名詞", translation: "疾病" },
  disease: { pos: "名詞", translation: "疾病" },
  sickness: { pos: "名詞", translation: "疾病" },
  cold: { pos: "名詞", translation: "感冒" },
  flu: { pos: "名詞", translation: "流感" },
  fever: { pos: "名詞", translation: "發燒" },
  headache: { pos: "名詞", translation: "頭痛" },
  stomachache: { pos: "名詞", translation: "胃痛" },
  toothache: { pos: "名詞", translation: "牙痛" },
  earache: { pos: "名詞", translation: "耳朵痛" },
  backache: { pos: "名詞", translation: "背痛" },
  pain: { pos: "名詞", translation: "疼痛" },
  ache: { pos: "名詞", translation: "痛" },
  injury: { pos: "名詞", translation: "傷害" },
  wound: { pos: "名詞", translation: "傷口" },
  cut: { pos: "名詞", translation: "切傷" },
  bruise: { pos: "名詞", translation: "瘀傷" },
  scratch: { pos: "名詞", translation: "抓傷" },
  burn: { pos: "名詞", translation: "燒傷" },
  blister: { pos: "名詞", translation: "水泡" },
  scar: { pos: "名詞", translation: "疤痕" },
  rash: { pos: "名詞", translation: "皮疹" },
  allergy: { pos: "名詞", translation: "過敏" },
  sneeze: { pos: "名詞", translation: "噴嚏" },
  cough: { pos: "名詞", translation: "咳嗽" },
  hiccup: { pos: "名詞", translation: "打嗝" },
  yawn: { pos: "名詞", translation: "哈欠" },
  burp: { pos: "名詞", translation: "打嗝" },
  temperature: { pos: "名詞", translation: "體溫" },
  thermometer: { pos: "名詞", translation: "溫度計" },
  stethoscope: { pos: "名詞", translation: "聽診器" },
  wheelchair: { pos: "名詞", translation: "輪椅" },
  crutch: { pos: "名詞", translation: "拐杖" },
  crutches: { pos: "名詞", translation: "拐杖" },
  cast: { pos: "名詞", translation: "石膏" },
  sling: { pos: "名詞", translation: "吊帶" },

  // More Nouns - Feelings and States
  feeling: { pos: "名詞", translation: "感覺" },
  emotion: { pos: "名詞", translation: "情緒" },
  mood: { pos: "名詞", translation: "心情" },
  happiness: { pos: "名詞", translation: "快樂" },
  joy: { pos: "名詞", translation: "喜悅" },
  sadness: { pos: "名詞", translation: "悲傷" },
  sorrow: { pos: "名詞", translation: "悲傷" },
  anger: { pos: "名詞", translation: "憤怒" },
  fear: { pos: "名詞", translation: "恐懼" },
  surprise: { pos: "名詞", translation: "驚訝" },
  excitement: { pos: "名詞", translation: "興奮" },
  boredom: { pos: "名詞", translation: "無聊" },
  interest: { pos: "名詞", translation: "興趣" },
  curiosity: { pos: "名詞", translation: "好奇心" },
  confidence: { pos: "名詞", translation: "信心" },
  courage: { pos: "名詞", translation: "勇氣" },
  bravery: { pos: "名詞", translation: "勇敢" },
  fear: { pos: "名詞", translation: "害怕" },
  worry: { pos: "名詞", translation: "擔心" },
  anxiety: { pos: "名詞", translation: "焦慮" },
  stress: { pos: "名詞", translation: "壓力" },
  relief: { pos: "名詞", translation: "解脫" },
  comfort: { pos: "名詞", translation: "舒適" },
  peace: { pos: "名詞", translation: "和平" },
  harmony: { pos: "名詞", translation: "和諧" },
  conflict: { pos: "名詞", translation: "衝突" },
  argument: { pos: "名詞", translation: "爭論" },
  disagreement: { pos: "名詞", translation: "分歧" },
  agreement: { pos: "名詞", translation: "同意" },
  decision: { pos: "名詞", translation: "決定" },
  choice: { pos: "名詞", translation: "選擇" },
  option: { pos: "名詞", translation: "選項" },
  opinion: { pos: "名詞", translation: "意見" },
  idea: { pos: "名詞", translation: "想法" },
  thought: { pos: "名詞", translation: "思想" },
  plan: { pos: "名詞", translation: "計劃" },
  intention: { pos: "名詞", translation: "意圖" },
  purpose: { pos: "名詞", translation: "目的" },
  reason: { pos: "名詞", translation: "原因" },
  cause: { pos: "名詞", translation: "原因" },
  result: { pos: "名詞", translation: "結果" },
  consequence: { pos: "名詞", translation: "後果" },
  outcome: { pos: "名詞", translation: "結果" },
  effect: { pos: "名詞", translation: "效果" },
  impact: { pos: "名詞", translation: "影響" },
  influence: { pos: "名詞", translation: "影響" },
  power: { pos: "名詞", translation: "力量" },
  strength: { pos: "名詞", translation: "力量" },
  weakness: { pos: "名詞", translation: "弱點" },
  ability: { pos: "名詞", translation: "能力" },
  skill: { pos: "名詞", translation: "技能" },
  talent: { pos: "名詞", translation: "天賦" },
  gift: { pos: "名詞", translation: "天賦" },
  knowledge: { pos: "名詞", translation: "知識" },
  wisdom: { pos: "名詞", translation: "智慧" },
  intelligence: { pos: "名詞", translation: "智力" },
  experience: { pos: "名詞", translation: "經驗" },
  practice: { pos: "名詞", translation: "練習" },
  effort: { pos: "名詞", translation: "努力" },
  attempt: { pos: "名詞", translation: "嘗試" },
  trial: { pos: "名詞", translation: "嘗試" },
  mistake: { pos: "名詞", translation: "錯誤" },
  error: { pos: "名詞", translation: "錯誤" },
  fault: { pos: "名詞", translation: "過錯" },
  success: { pos: "名詞", translation: "成功" },
  failure: { pos: "名詞", translation: "失敗" },
  achievement: { pos: "名詞", translation: "成就" },
  accomplishment: { pos: "名詞", translation: "成就" },
  victory: { pos: "名詞", translation: "勝利" },
  defeat: { pos: "名詞", translation: "失敗" },
  loss: { pos: "名詞", translation: "損失" },
  gain: { pos: "名詞", translation: "收穫" },
  profit: { pos: "名詞", translation: "利潤" },
  benefit: { pos: "名詞", translation: "益處" },
  advantage: { pos: "名詞", translation: "優勢" },
  disadvantage: { pos: "名詞", translation: "劣勢" },
  problem: { pos: "名詞", translation: "問題" },
  solution: { pos: "名詞", translation: "解決方案" },
  answer: { pos: "名詞", translation: "答案" },
  question: { pos: "名詞", translation: "問題" },
  riddle: { pos: "名詞", translation: "謎語" },
  mystery: { pos: "名詞", translation: "神秘" },
  secret: { pos: "名詞", translation: "秘密" },
  clue: { pos: "名詞", translation: "線索" },
  hint: { pos: "名詞", translation: "提示" },
  tip: { pos: "名詞", translation: "提示" },
  warning: { pos: "名詞", translation: "警告" },
  danger: { pos: "名詞", translation: "危險" },
  risk: { pos: "名詞", translation: "風險" },
  safety: { pos: "名詞", translation: "安全" },
  security: { pos: "名詞", translation: "安全" },
  protection: { pos: "名詞", translation: "保護" },
  defense: { pos: "名詞", translation: "防禦" },
  attack: { pos: "名詞", translation: "攻擊" },
  battle: { pos: "名詞", translation: "戰鬥" },
  war: { pos: "名詞", translation: "戰爭" },
  peace: { pos: "名詞", translation: "和平" },

  // Story and Literature Words
  story: { pos: "名詞", translation: "故事" },
  tale: { pos: "名詞", translation: "故事" },
  fable: { pos: "名詞", translation: "寓言" },
  legend: { pos: "名詞", translation: "傳說" },
  myth: { pos: "名詞", translation: "神話" },
  fairy: { pos: "名詞", translation: "仙女" },
  prince: { pos: "名詞", translation: "王子" },
  princess: { pos: "名詞", translation: "公主" },
  king: { pos: "名詞", translation: "國王" },
  queen: { pos: "名詞", translation: "皇后" },
  castle: { pos: "名詞", translation: "城堡" },
  palace: { pos: "名詞", translation: "宮殿" },
  tower: { pos: "名詞", translation: "塔" },
  dragon: { pos: "名詞", translation: "龍" },
  monster: { pos: "名詞", translation: "怪物" },
  giant: { pos: "名詞", translation: "巨人" },
  dwarf: { pos: "名詞", translation: "矮人" },
  wizard: { pos: "名詞", translation: "巫師" },
  witch: { pos: "名詞", translation: "女巫" },
  magic: { pos: "名詞", translation: "魔法" },
  spell: { pos: "名詞", translation: "咒語" },
  wand: { pos: "名詞", translation: "魔杖" },
  potion: { pos: "名詞", translation: "魔藥" },
  treasure: { pos: "名詞", translation: "寶藏" },
  jewel: { pos: "名詞", translation: "珠寶" },
  crown: { pos: "名詞", translation: "王冠" },
  throne: { pos: "名詞", translation: "王座" },
  sword: { pos: "名詞", translation: "劍" },
  shield: { pos: "名詞", translation: "盾" },
  armor: { pos: "名詞", translation: "盔甲" },
  helmet: { pos: "名詞", translation: "頭盔" },
  knight: { pos: "名詞", translation: "騎士" },
  hero: { pos: "名詞", translation: "英雄" },
  heroine: { pos: "名詞", translation: "女英雄" },
  villain: { pos: "名詞", translation: "反派" },
  character: { pos: "名詞", translation: "角色" },
  author: { pos: "名詞", translation: "作者" },
  writer: { pos: "名詞", translation: "作家" },
  poet: { pos: "名詞", translation: "詩人" },
  poem: { pos: "名詞", translation: "詩" },
  verse: { pos: "名詞", translation: "詩句" },
  rhyme: { pos: "名詞", translation: "韻律" },
  chapter: { pos: "名詞", translation: "章節" },
  paragraph: { pos: "名詞", translation: "段落" },
  sentence: { pos: "名詞", translation: "句子" },
  word: { pos: "名詞", translation: "字" },
  letter: { pos: "名詞", translation: "字母" },
  alphabet: { pos: "名詞", translation: "字母表" },
  vowel: { pos: "名詞", translation: "母音" },
  consonant: { pos: "名詞", translation: "子音" },
  syllable: { pos: "名詞", translation: "音節" },
  phrase: { pos: "名詞", translation: "短語" },
  title: { pos: "名詞", translation: "標題" },
  heading: { pos: "名詞", translation: "標題" },
  caption: { pos: "名詞", translation: "標題" },
  label: { pos: "名詞", translation: "標籤" },
  tag: { pos: "名詞", translation: "標籤" },
  mark: { pos: "名詞", translation: "記號" },
  symbol: { pos: "名詞", translation: "符號" },
  sign: { pos: "名詞", translation: "符號" },

  // More Adjectives - More Descriptive
  enormous: { pos: "形容詞", translation: "巨大的" },
  huge: { pos: "形容詞", translation: "巨大的" },
  gigantic: { pos: "形容詞", translation: "巨大的" },
  massive: { pos: "形容詞", translation: "巨大的" },
  miniature: { pos: "形容詞", translation: "微型的" },
  giant: { pos: "形容詞", translation: "巨大的" },
  minor: { pos: "形容詞", translation: "較小的" },
  major: { pos: "形容詞", translation: "較大的" },
  maximum: { pos: "形容詞", translation: "最大的" },
  minimum: { pos: "形容詞", translation: "最小的" },
  average: { pos: "形容詞", translation: "平均的" },
  typical: { pos: "形容詞", translation: "典型的" },
  common: { pos: "形容詞", translation: "常見的" },
  rare: { pos: "形容詞", translation: "稀有的" },
  unique: { pos: "形容詞", translation: "獨特的" },
  individual: { pos: "形容詞", translation: "個別的" },
  personal: { pos: "形容詞", translation: "個人的" },
  private: { pos: "形容詞", translation: "私人的" },
  public: { pos: "形容詞", translation: "公開的" },
  secret: { pos: "形容詞", translation: "秘密的" },
  hidden: { pos: "形容詞", translation: "隱藏的" },
  visible: { pos: "形容詞", translation: "可見的" },
  invisible: { pos: "形容詞", translation: "看不見的" },
  clear: { pos: "形容詞", translation: "清楚的" },
  unclear: { pos: "形容詞", translation: "不清楚的" },
  obvious: { pos: "形容詞", translation: "明顯的" },
  vague: { pos: "形容詞", translation: "模糊的" },
  specific: { pos: "形容詞", translation: "具體的" },
  general: { pos: "形容詞", translation: "一般的" },
  exact: { pos: "形容詞", translation: "精確的" },
  approximate: { pos: "形容詞", translation: "大約的" },
  rough: { pos: "形容詞", translation: "粗略的" },
  precise: { pos: "形容詞", translation: "精確的" },
  accurate: { pos: "形容詞", translation: "準確的" },
  inaccurate: { pos: "形容詞", translation: "不準確的" },
  detailed: { pos: "形容詞", translation: "詳細的" },
  brief: { pos: "形容詞", translation: "簡短的" },
  lengthy: { pos: "形容詞", translation: "冗長的" },
  endless: { pos: "形容詞", translation: "無盡的" },
  limited: { pos: "形容詞", translation: "有限的" },
  unlimited: { pos: "形容詞", translation: "無限的" },
  infinite: { pos: "形容詞", translation: "無限的" },
  finite: { pos: "形容詞", translation: "有限的" },
  permanent: { pos: "形容詞", translation: "永久的" },
  temporary: { pos: "形容詞", translation: "暫時的" },
  constant: { pos: "形容詞", translation: "不變的" },
  variable: { pos: "形容詞", translation: "可變的" },
  stable: { pos: "形容詞", translation: "穩定的" },
  unstable: { pos: "形容詞", translation: "不穩定的" },
  steady: { pos: "形容詞", translation: "穩定的" },
  unsteady: { pos: "形容詞", translation: "不穩定的" },
  regular: { pos: "形容詞", translation: "規律的" },
  irregular: { pos: "形容詞", translation: "不規則的" },
  even: { pos: "形容詞", translation: "平均的" },
  uneven: { pos: "形容詞", translation: "不平的" },
  level: { pos: "形容詞", translation: "平的" },
  slanted: { pos: "形容詞", translation: "傾斜的" },
  vertical: { pos: "形容詞", translation: "垂直的" },
  horizontal: { pos: "形容詞", translation: "水平的" },
  diagonal: { pos: "形容詞", translation: "對角線的" },
  parallel: { pos: "形容詞", translation: "平行的" },
  perpendicular: { pos: "形容詞", translation: "垂直的" },
  opposite: { pos: "形容詞", translation: "相反的" },
  reverse: { pos: "形容詞", translation: "相反的" },
  backward: { pos: "形容詞", translation: "向後的" },
  forward: { pos: "形容詞", translation: "向前的" },
  upside: { pos: "形容詞", translation: "上方的" },
  downside: { pos: "形容詞", translation: "下方的" },
  rightside: { pos: "形容詞", translation: "右側的" },
  leftside: { pos: "形容詞", translation: "左側的" },
  inner: { pos: "形容詞", translation: "內部的" },
  outer: { pos: "形容詞", translation: "外部的" },
  interior: { pos: "形容詞", translation: "內部的" },
  exterior: { pos: "形容詞", translation: "外部的" },
  upper: { pos: "形容詞", translation: "上層的" },
  lower: { pos: "形容詞", translation: "下層的" },
  central: { pos: "形容詞", translation: "中央的" },
  middle: { pos: "形容詞", translation: "中間的" },
  initial: { pos: "形容詞", translation: "最初的" },
  final: { pos: "形容詞", translation: "最後的" },
  original: { pos: "形容詞", translation: "原始的" },
  modern: { pos: "形容詞", translation: "現代的" },
  ancient: { pos: "形容詞", translation: "古代的" },
  recent: { pos: "形容詞", translation: "最近的" },
  current: { pos: "形容詞", translation: "當前的" },
  past: { pos: "形容詞", translation: "過去的" },
  present: { pos: "形容詞", translation: "現在的" },
  future: { pos: "形容詞", translation: "未來的" },
  previous: { pos: "形容詞", translation: "以前的" },
  next: { pos: "形容詞", translation: "下一個的" },
  following: { pos: "形容詞", translation: "接下來的" },
  preceding: { pos: "形容詞", translation: "前面的" },
  former: { pos: "形容詞", translation: "從前的" },
  latter: { pos: "形容詞", translation: "後者的" },
  earlier: { pos: "形容詞", translation: "較早的" },
  later: { pos: "形容詞", translation: "較晚的" },
  sooner: { pos: "形容詞", translation: "更早的" },
  immediate: { pos: "形容詞", translation: "立即的" },
  instant: { pos: "形容詞", translation: "即時的" },
  gradual: { pos: "形容詞", translation: "逐漸的" },
  sudden: { pos: "形容詞", translation: "突然的" },
  abrupt: { pos: "形容詞", translation: "突然的" },
  swift: { pos: "形容詞", translation: "迅速的" },
  rapid: { pos: "形容詞", translation: "快速的" },
  speedy: { pos: "形容詞", translation: "快速的" },
  hasty: { pos: "形容詞", translation: "匆忙的" },
  leisurely: { pos: "形容詞", translation: "悠閒的" },
  relaxing: { pos: "形容詞", translation: "放鬆的" },
  stressful: { pos: "形容詞", translation: "有壓力的" },
  pleasant: { pos: "形容詞", translation: "愉快的" },
  unpleasant: { pos: "形容詞", translation: "不愉快的" },
  enjoyable: { pos: "形容詞", translation: "令人享受的" },
  boring: { pos: "形容詞", translation: "無聊的" },
  interesting: { pos: "形容詞", translation: "有趣的" },
  exciting: { pos: "形容詞", translation: "令人興奮的" },
  dull: { pos: "形容詞", translation: "枯燥的" },
  thrilling: { pos: "形容詞", translation: "刺激的" },
  terrifying: { pos: "形容詞", translation: "可怕的" },
  frightening: { pos: "形容詞", translation: "令人害怕的" },
  scary: { pos: "形容詞", translation: "可怕的" },
  spooky: { pos: "形容詞", translation: "詭異的" },
  creepy: { pos: "形容詞", translation: "令人毛骨悚然的" },
  mysterious: { pos: "形容詞", translation: "神秘的" },
  magical: { pos: "形容詞", translation: "神奇的" },
  enchanting: { pos: "形容詞", translation: "迷人的" },
  charming: { pos: "形容詞", translation: "迷人的" },
  attractive: { pos: "形容詞", translation: "吸引人的" },
  unattractive: { pos: "形容詞", translation: "不吸引人的" },
  handsome: { pos: "形容詞", translation: "英俊的" },
  gorgeous: { pos: "形容詞", translation: "華麗的" },
  stunning: { pos: "形容詞", translation: "驚艷的" },
  lovely: { pos: "形容詞", translation: "可愛的" },
  cute: { pos: "形容詞", translation: "可愛的" },
  adorable: { pos: "形容詞", translation: "討人喜愛的" },
  precious: { pos: "形容詞", translation: "珍貴的" },
  valuable: { pos: "形容詞", translation: "有價值的" },
  worthless: { pos: "形容詞", translation: "無價值的" },
  priceless: { pos: "形容詞", translation: "無價的" },
  expensive: { pos: "形容詞", translation: "昂貴的" },
  cheap: { pos: "形容詞", translation: "便宜的" },
  costly: { pos: "形容詞", translation: "昂貴的" },
  affordable: { pos: "形容詞", translation: "買得起的" },
  free: { pos: "形容詞", translation: "免費的" }
};

export default TRANSLATION_DICTIONARY;
